import {FetchUtil} from "./fetch_util";
import success from "../../iconfont/success";
import Util from "./utils";

const DOMAIN = process.env.REACT_APP_DOMAIN;
const URL_GET_CUSTOMER_TAG_LIST = DOMAIN + '/corp/customer/tag_list';
const URL_GET_TAG_LIST = DOMAIN + '/corp/crm/taglist';
//用户登录
const URL_USER_LOGIN = DOMAIN + '/user/signin';
const URL_USER_REGISTER = DOMAIN + '/user/signup';
const URL_USER_CAPTCHA = DOMAIN + '/user/captcha';
const URL_USER_FINDPASS = DOMAIN + '/user/reset_pwd';
const URL_GET_USER_OPENID = DOMAIN + '/user/base_info';
const URL_USER_LOGIN_STATUS = DOMAIN + '/user/login_status' //获取登录状态
const URL_USER_EXIT = DOMAIN + '/user/logout';
const URL_DEL_MARKET_ORDER_CHECKER = DOMAIN + '/orderchecker/delete';
const URL_GET_MARKET_ORDER_CHECKER_LIST = DOMAIN + '/orderchecker/list';
const URL_GET_ADD_TAG_GROUP = DOMAIN + '/corp/crm/addtaggroup'; //添加标签组
//配置
const URL_GET_SUBS_MAG_TEMPLATE_LIST = DOMAIN + '/conf/subs/msg_template_list'
//一元解锁
const URL_GET_MARKET_PZUNLOCK_PROMOTOINFO = DOMAIN + '/boost/promoto';

const URL_GET_BOOST_REDEEMCODE_BINDING = DOMAIN + '/boost/redeemcode/binding'  //一元解锁活动绑定的兑换码礼品
//兑换码
const URL_GET_MARKET_REDEEMCODE_LIST = DOMAIN + '/redeemcode/alllist';
const URL_EXPORT_REDEEMCODE_DATA = DOMAIN + '/redeemcode/export';

//批量发货
const URL_GET_ORDER_BULKDELIVER_RECORDLIST = DOMAIN + '/order/bulkdeliver/recordlist'
const URL_GET_ORDER_BULKDELIVER_UPLOAD_DATA = DOMAIN + '/order/bulkdeliver/uploadData' //上传批量发货数据
const URL_GET_ORDER_BULKDELIVER_DELETE = DOMAIN + '/order/bulkdeliver/delete' //删除批量发货记录

//分销
const URL_GET_MARKET_DISTRI_ACTIVITY_NAMELIST = DOMAIN + '/distri/menulist';
const URL_GET_MARKET_DISTRI_CHANNEL_LIST = DOMAIN + '/distri/channel/query';
const URL_DEL_MARKET_DISTRI_CHANNEL = DOMAIN + '/distri/channel/delete?channelId=';
const URL_GET_MARKET_DISTRI_CHANNEL_PROMOINFO = DOMAIN + '/distri/channel/promoinfo?channelId=';

//客户标签
const URL_UPDATE_TAG_ORDER = DOMAIN + '/corp/crm/taggrouporder'; //标签组排序
const URL_GET_COMPILE_TAG_GROUP = DOMAIN + '/corp/crm/edittaggroup' //编辑标签组
const URL_ADD_TAG = DOMAIN + '/corp/crm/addtag'; //添加标签
const URL_ADD_BATTAG = DOMAIN + '/corp/crm/battag' //批量打标签
const URL_DELETE_TAGS = DOMAIN + '/corp/crm/battag/del' //批量删除标签
const URL_SYNC_TAG = DOMAIN + '/corp/crm/synctag' //同步标签

//客户管理
const URL_POST_CRM_CUSTOMERLIST = DOMAIN + '/corp/crm/customerlist' //客户列表
const URL_GET_CRM_BLACKLIST = DOMAIN + '/corp/crm/blacklist' //黑名单列表
const URL_PULL_CRM_BLACK = DOMAIN + '/corp/crm/pullblack' //拉黑
const URL_REMOVE_BLACK_LIST = DOMAIN + '/corp/crm/blacklist/remove' //移除黑名单

//渠道列表
const URL_GET_CHANNEL_LIST = DOMAIN + '/corp/taskactivity/channel/list' //获取渠道列表
const URL_CREATE_CHANNEL = DOMAIN + '/corp/taskactivity/channel/create' //新建渠道
const URL_DELETE_CHANNEL = DOMAIN + '/corp/taskactivity/channel/del' //删除渠道
const URL_GET_CHANNEL_PROMOINFO = DOMAIN + '/corp/taskactivity/channel/promoinfo' //渠道推广
const URL_EDIT_CHANNEL_INFO = DOMAIN + '/corp/taskactivity/channel/edit' //编辑渠道
const URL_GET_CHANNEL_INFO = DOMAIN + '/corp/taskactivity/channel/detail' //获取渠道详情
const URL_GET_ACTIVITY_NAME_LIST = DOMAIN + '/corp/taskactivity/namelist' //获取活动name列表
const URL_GET_CHANNEL_MENU_LIST = DOMAIN + '/corp/taskactivity/channel/menulist' //获取渠道下拉列表
const URL_GET_TASK_MEMBER_LIST = DOMAIN + '/corp/taskactivity/memberlist' //活动所属成员下拉列表

//活动数据
const URL_GET_TASK_ACTIVITY_STATS = DOMAIN + '/corp/taskactivity/activitystats' //数据统计

//参与用户
const URl_GET_ACTIVITY_CUSTOMER_LIST = DOMAIN + '/corp/taskactivity/customerlist' //参与用户 表格的数据
const URL_GET_ACTIVITY_CUSTOMER_STATS = DOMAIN + '/corp/taskactivity/customerstats' //参与用户 统计的数据
//参与用户 --> 邀请详情
const URL_GET_ACTIVITY_INVITED_DETAIL = DOMAIN + '/corp/taskactivity/invitedetail' //邀请详情
const URL_GET_ACTIVITY_INVITE_CUSTOMER_LIST = DOMAIN + '/corp/taskactivity/invitelist' //邀请客户列表

//活动管理
const URL_CORP_CRM_CORPUSER_PAGE = DOMAIN + '/corp/crm/corpuser/page' //新的获取成员的接口
const URL_GET_MEMBER_SYNC = DOMAIN + '/corp/member/sync'//同步成员接口

const URL_GET_ACTIVITY_LIST = DOMAIN + '/corp/taskactivity/tasklist' //获取活动管理列表
const URL_GET_ACTIVITY_USABLE_OFFICIAL = DOMAIN + '/corp/taskactivity/oalist' //获取可用的公众号
const URL_GET_ACTIVITY_PROMOINFO = DOMAIN + '/corp/taskactivity/promoinfo' //获取活动推广信息
const URL_GET_GAIN_SERVICE_MEMBER_LIST = DOMAIN + '/corp/crm/corpuser' //获取客服成员列表
const URL_GET_ENTERPRISE_MICRO_TASK_TREASURE_NEW_ACTIVITIES = DOMAIN + '/corp/taskactivity/create' //任务宝活动管理页面新建活动
const URL_GET_ENTERPRISE_MICRO_TASK_TREASURE_EDITING_ACTIVITY = DOMAIN + '/corp/taskactivity/edit' //任务宝活动管理编辑活动
const URL_GET_ENTERPRISE_OBTAIN_ACTIVITY_INFORMATION = DOMAIN + '/corp/taskactivity/detail' //获取活动信息
const URL_GET_ENTERPRISE_OBTAIN_DELETE_ACTIVITY = DOMAIN + '/corp/taskactivity/del' //删除活动
const URL_GET_TASKACTIVITY_REDEEMCODE_BINDING = DOMAIN + '/corp/taskactivity/redeemcode/binding'//任务裂变活动绑定的兑换码礼品

//配置管理
const URL_GET_SUBS_OALIST = DOMAIN + '/conf/subs/oalist'; //获取公众号列表
const URL_GET_SUBS_AUTHURL = DOMAIN + '/wechat/auth_uri'; //获取公众号授权地址
const URL_GET_WXPAY_DETAIL = DOMAIN + '/conf/payconfig/wx/detail'; //获取微信支付配置
const URL_ADD_WXPAY = DOMAIN + '/conf/payconfig/wx/add'; //保存微信支付配置
const URL_GET_WXPAY_DOMAIN = DOMAIN + '/conf/payconfig/wx/pay_domain'; //获取微信支付目录
const URL_EDIT_WXPAY_CONFIG = DOMAIN + '/conf/payconfig/wx/edit'; //编辑微信支付
const URL_GET_WXPAY_SUBSINFO = DOMAIN + '/conf/subs/pay/detail'; //编辑微信支付

const URL_GET_ENTERPRISE_OBTAIN_CLOSE_ACTIVITY = DOMAIN + '/corp/taskactivity/turnoff' //关闭活动
const URL_GET_ENTERPRISE_OBTAIN_OPEN_ACTIVITY = DOMAIN + '/corp/taskactivity/turnon' //开启活动
const URL_GET_ENTERPRISE_OBTAIN_MASS_COUNT_PEOPLENUMBER = DOMAIN + '/corp/taskactivity/group/countReceiver' //群发页面统计客户人数
const URL_GET_NEW_MASS_INFORMATION = DOMAIN + '/corp/taskactivity/group/create' //群发新建群发消息
const URL_GET_MASS_DETAIL_DATA = DOMAIN + '/corp/taskactivity/group/detail' //获取群发详情数据

//企业微信授权
const URL_GET_ENTERPRISE_WECHAT_AUTHORIZTION_STUATUS = DOMAIN + '/corp/auth/status' //企业微信授权状态4
const URL_GET_CORP_AUTH_TEMPLATE_AUTH_CODE = DOMAIN + '/corp/auth/templateauthcode' //请求代开发的二维码接口
// const URL_GET_APPLICATION_FUNCTION_MESSAGE=DOMAIN + '/corp/auth/callbackinfo'//获取自建应用功能接口回调信息7
const URL_GET_GO_ENTERPRISE_WEIXIN_AUTHORIZTION = DOMAIN + '/corp/auth/auth_uri' //企业微信授权按钮
const URL_GET_CALLBACK_USE_MESSAGE = DOMAIN + '/corp/auth/callbackinfo' // 获取自建应用功能接口回调信息
const URL_SUBMIT_SELT_BULID_USE_MESSAGE = DOMAIN + '/corp/auth/selfbuildapp' //提交自建应用信息2
const URL_SUBMIT_CLIENT_RELATION_PASSWORD = DOMAIN + '/corp/auth/externalcontact' //提交客户联系功能密码1,8
const URL_MODIFICATION_AUTHORIZATION_STATE = DOMAIN + '/corp/auth/nextstep' //修改企微授权状态（点下一步时调用）3
const URL_GAIN_CLIENT_AUTHORIZATION_PARAMETER = DOMAIN + '/corp/auth/detail' //获取客户授权参数6
const URL_MODIFICATION_CLIENT_AUTHORIZATION = DOMAIN + '/corp/auth/edit' //修改客户授权参数
const URL_FORM_UNBOUND = DOMAIN + '/form/unbound' //获取可用表单列表

const URL_SYNC_CUSTOMER = DOMAIN + '/corp/crm/syncCustomer' //同步客户

//资产
const URL_GET_ASSETS_CASHABLE = DOMAIN + '/assets/account/cashable'; //获取可提现金额
const URL_APPLY_WITHDRAW = DOMAIN + '/assets/withdraw/apply'; //申请提现
const URL_GET_ASSETS_STATEMENT_LIST = DOMAIN + '/assets/statement/details'; //获取对账单明细
const URL_CALC_RECHARGE_AMOUNT = DOMAIN + '/assets/account/recharge/calc_actual_amount'; //计算充值金额
const URL_UNIFIED_RECHARGE_ORDER = DOMAIN + '/assets/account/recharge/unified_order'; //充值下单
const URL_GET_ASSETS_RECHARGE_WXPAYQRCODE = DOMAIN + '/assets/account/recharge/wxpay_qrcode'; //充值下单
const URL_GET_ASSETS_RECHARGE_WXPAYRESULT = DOMAIN + '/assets/account/recharge/wxpay_result'; //充值下单


//群裂变
const URL_GET_GROUPFISSION_SYNCGROUPCHATLIST = DOMAIN + '/corp/groupfission/syncGroupChatList' //同步群聊
const URL_GET_GROUPFISSION_SYNCGROUPCHATSTATUS = DOMAIN + '/corp/groupfission/syncGroupChatStatus' //判断群聊是否同步完成
const URL_GET_GROUPFISSION_GROUPLIST = DOMAIN + '/corp/groupfission/grouplist' // 获取全部外部群聊列表
const URL_CORP_GROUPFISSION_CREATE = DOMAIN + '/corp/groupfission/create' //群裂变新建活动
const URL_GET_GROUP_ACTIVITY_LIST = DOMAIN + '/corp/groupfission/fissionlist' // 活动列表
const URL_CORP_GROUPFISSION_EDIT = DOMAIN + '/corp/groupfission/edit' //群裂变编辑活动
const URL_CORP_GROUPFISSION_DETAIL = DOMAIN + '/corp/groupfission/detail' //群裂变获取活动信息
const URL_CORP_GROUPFISSION_DEL = DOMAIN + '/corp/groupfission/del' //群裂变删除活动
const URL_GET_GROUP_PROMOINFO = DOMAIN + '/corp/groupfission/promoinfo' //推广信息
const URL_OPEN_GROUP_ACTIVITY = DOMAIN + '/corp/groupfission/turnon' // 开启活动
const URL_OFF_GROUP_ACTIVITY = DOMAIN + '/corp/groupfission/turnoff' // 关闭活动
const URL_GET_GROUP_ACTIVITY_NAME_LIST = DOMAIN + '/corp/groupfission/namelist' // 活动名称下拉列表
const URL_GET_GROUP_CHANNEL_LIST = DOMAIN + '/corp/groupfission/channel/list' // 渠道列表
const URL_GET_GROUP_CHANNEL_PROMOINFO = DOMAIN + '/corp/groupfission/channel/promoinfo' // 渠道推广
const URL_DELETE_GROUP_CHANNEL = DOMAIN + '/corp/groupfission/channel/del' // 删除渠道
const URL_GET_GROUP_CHANNEL_MENU_LIST = DOMAIN + '/corp/groupfission/channel/menulist' // 删除渠道
const URL_GET_GROUP_STATS = DOMAIN + '/corp/groupfission/groupstats' // 群聊数据
const URL_GET_GROUP_CUSTOMER_STATS = DOMAIN + '/corp/groupfission/customerstats' // 客户数据
const URL_GET_GROUP_STATS_EXPORT = DOMAIN + '/corp/groupfission/groupstats_export' // 客户数据
const URL_EDIT__GROUP_CHANNEL_INFO = DOMAIN + '/corp/groupfission/channel/edit' //编辑渠道
const URL_CREATE_GROUP_CHANNEL = DOMAIN + '/corp/groupfission/channel/create' //新建渠道
const URL_GET_GROUP_CHANNEL_INFO = DOMAIN + '/corp/groupfission/channel/detail' //获取渠道详情
const URL_GET_GROUP_MASTER_LIST = DOMAIN + '/corp/groupfission/masterlist' //群主下拉列表
const URL_GET_GROUP_ACTIVITY_STATS = DOMAIN + '/corp/groupfission/activitystats' //数据统计
const URL_GET_GROUP_INVITED_DETAIL = DOMAIN + '/corp/groupfission/invitedetail' //邀请详情
const URL_GET_GROUP_INVITE_CUSTOMER_LIST = DOMAIN + '/corp/groupfission/invitelist' //邀请列表
const URL_GET_REDEEMCODE_UNBINDLIST = DOMAIN + '/redeemcode/unbindlist' //群裂变兑换码
const URL_GET_GROUPFISSION_REDEEMCODE_BINDING = DOMAIN + '/corp/groupfission/redeemcode/binding'//群裂变活动绑定的兑换码礼品
//成员管理
const URL_GET_MEMBER_TREE = DOMAIN + '/corp/member/deptlist' //部门树
const URL_GET_MEMBER_LIST = DOMAIN + '/corp/member/memberlist' //成员列表
const URL_SYNC_MEMBER = DOMAIN + '/corp/member/sync' //同步成员

//到期续费
const URL_PRODUCT_RENEWLIS = DOMAIN + '/product/renewlist' //需要续费的产品
const URL_PRODUCT_ORDER_LIST = DOMAIN + '/product/orderl/list' //获取订单列表
const URL_GET_PRODUCT_STATUS = DOMAIN + '/product/get_product_status' //获取是否到期
const URL_PRODUCT_GROUP_LIST = DOMAIN + '/product/productgrouplist' //组合产品列表
const URL_GET_PRODUCT_LIST = DOMAIN + '/product/productlist' //获取单独的产品列表
const URL_PRODUCT_ORDER_WXPAY_QRCODE = DOMAIN + '/product/order/wxpay_qrcode' //获取微信二维码
const URL_PRODUCT_ORDER_UNIFIED = DOMAIN + '/product/order/unified' //获取下单的接口
const URL_PRODUCT_ORDER_CALCPRICE = DOMAIN + '/product/order/calcprice' //计算价格
const URL_PRODUCT_ORDER_MANUAL_REVIEW = DOMAIN + '/product/order/manual_review' //提交凭证
const URL_PRODUCT_ORDER_WXPAY_RESULT = DOMAIN + '/product/order/wxpay_result' //获取支付结果
const URL_PRODUCT_ORDER_CLOSE = DOMAIN + '/product/order/close' //取消订单

const URL_PRODUCT_PROSEAT_PIRCEINFO = DOMAIN + '/product/proseat_pirceinfo'//席位价格信息


//首页数据
const URL_GET_HOME_DATA = DOMAIN + '/home/data' //首页数据
const URL_GET_HOME_USER_INFO = DOMAIN + '/home/userinfo' //首页 用户信息
const URL_GET_HOME_LOG = DOMAIN + '/home/log' //首页 更新日志

//红包裂变
const URL_CREATE_REDPACKET_ACTIVITY = DOMAIN + '/redpacket/create' //创建红包活动
const URL_GET_REDPACKET_LIST = DOMAIN + '/redpacket/query' //红包活动列表
const URL_GET_REDPACKET_PROMOINFO = DOMAIN + '/redpacket/promoinfo' //红包活动 推广
const URL_CLOSE_REDPACKET_ACTIVITY = DOMAIN + '/redpacket/close' //关闭活动
const URL_OPEN_REDPACKET_ACTIVITY = DOMAIN + '/redpacket/turnon' //开启活动
const URL_DELETE_REDPACKET_ACTIVITY = DOMAIN + '/redpacket/delete' //删除活动
const URL_GET_REDPACKET_SEND_DETAIL = DOMAIN + '/redpacket/groupmsg/detail' //群发详情
const URL_CREATE_REDPACKET_SEND = DOMAIN + '/redpacket/groupmsg/create' //群发消息创建
const URL_GET_REDPACKET_ACTIVITY_DETAIL = DOMAIN + '/redpacket/detail' //活动详情
const URL_EDIT_REDPACKET_ACTIVITY = DOMAIN + '/redpacket/modify' //活动编辑
const URL_GET_REDPACKET_CHANNEL_LIST = DOMAIN + '/redpacket/channel/query' //渠道列表
const URL_CREATE_REDPACKET_CHANNEL = DOMAIN + '/redpacket/channel/create' //渠道创建
const URL_DELETE_REDPACKET_CHANNEL = DOMAIN + '/redpacket/channel/delete' //渠道删除
const URL_EDIT_REDPACKET_CHANNEL = DOMAIN + '/redpacket/channel/edit' //渠道修改
const URL_GET_REDPACKET_CHANNEL_DETAIL = DOMAIN + '/redpacket/channel/detail' //渠道详情
const URL_GET_REDPACKET_CHANNEL_PROMOINFO = DOMAIN + '/redpacket/channel/promoinfo' //渠道详情
const URL_GET_REDPACKET_ACTIVITY_NAME_LIST = DOMAIN + '/redpacket/namelist' //活动下拉列表
const URL_GET_REDPACKET_REPORT = DOMAIN + '/redpacket/stats' //数据统计
const URL_GET_REDPACKET_CHANNEL_MENULIST = DOMAIN + '/redpacket/channel/menulist' //渠道下拉列表
const URL_GET_REDPACKET_CUSTOMER_LIST = DOMAIN + '/redpacket/customerlist' //客户列表
const URL_GET_REDPACKET_INVITE_DETAIL = DOMAIN + '/redpacket/invitedetail' //邀请详情
const URL_GET_REDPACKET_INVITE_LIST = DOMAIN + '/redpacket/invitelist' //邀请详情 客户列表
const URL_GET_REDPACKET_MEMBER_LIST = DOMAIN + '/redpacket/memberlist' //所属成员列表


//抽奖裂变
const URL_GET_LOTTERY_QUERY = DOMAIN + '/corp/lottery/query'//抽奖裂变活动管理的列表数据
const URL_GET_LOTTERY_NAME_LIST = DOMAIN + '/corp/lottery/namelist'//数据统计的活动下拉列表
const URL_GET_LOTTERY_CHANNEL_MENULIST = DOMAIN + '/corp/lottery/channel/menulist' //数据统计的渠道下拉列表
const URL_GET_LOTTERY_CHANNEL_QUERY = DOMAIN + '/corp/lottery/channel/query' //抽奖裂变的渠道列表
const URL_GET_LOTTERY_CREATE = DOMAIN + '/corp/lottery/create' //抽奖裂变的新建活动
const URL_GET_LOTTERY_DETAIL = DOMAIN + '/corp/lottery/detail'//抽奖裂变详情
const URL_GET_LOTTERY_MODIFY = DOMAIN + '/corp/lottery/modify' //抽奖裂变的编辑
const URL_GET_LOTTERY_DELETE = DOMAIN + '/corp/lottery/delete'//抽奖裂变的删除活动
const URL_Get_LOTTERY_PROMOTE = DOMAIN + '/corp/lottery/promote'//抽奖裂变的推广
const URL_GET_LOTTERY_TURNOFF = DOMAIN + '/corp/lottery/turnoff'//抽奖裂变的关闭活动
const URL_GET_LOTTERY_TURNON = DOMAIN + '/corp/lottery/turnon'//抽奖裂变的开启活动
const URL_GET_LOTTERY_STATS = DOMAIN + '/corp/lottery/stats'//抽奖裂变的数据统计的
const URL_GET_LOTTERY_MEMBER_LIST = DOMAIN + '/corp/lottery/memberlist'//抽奖裂变的数据统计的所属成员下拉列表
const URL_GET_LOTTERY_CUSTOMER_LIST = DOMAIN + '/corp/lottery/customerlist'//抽奖裂变的数据统计表格数据
const URL_GET_LOTTERY_CUSTOMER_RECEIVE_LIST = DOMAIN + '/corp/lottery/customerReceiveList'//抽奖裂变的数据统计客户抽奖详情
const URL_GET_LOTTERY_INVIT_DETAIL = DOMAIN + '/corp/lottery/invitdetail' //抽奖裂变的数据统计的邀请详情
const URL_GET_LOTTERY_INVITE_LIST = DOMAIN + '/corp/lottery/invitelist'//抽奖裂变的数据统计的邀请客户列表
const URL_GET_LOTTERY_CHANNEL_CREATE = DOMAIN + '/corp/lottery/channel/create'//创建渠道
const URL_GET_LOTTERY_CHANNEL_MODIFY = DOMAIN + '/corp/lottery/channel/modify'//抽奖裂变的编辑渠道
const URL_GET_LOTTERY_CHANNEL_DETAIL = DOMAIN + '/corp/lottery/channel/detail' //获取渠道的详情
const URL_GET_LOTTERY_CHANNEL_PROMOINFO = DOMAIN + '/corp/lottery/channel/promoinfo'//渠道推广
const URL_GET_LOTTERY_CHANNEL_DELETE = DOMAIN + '/corp/lottery/channel/delete' //删除渠道
const URL_GET_LOTTERY_REDEEM_CODE_LIST = DOMAIN + '/corp/lottery/redeemcodeList'//抽奖裂变的兑换码记录
//渠道活码
const URL_LIVECODE_GROUPLIST = DOMAIN + '/corp/livecode/grouplist' //03 活码分组列表
const URL_LIVECODE_ACTIVITYLIST = DOMAIN + '/corp/livecode/activitylist' //活码列表
const URL_LIVECODE_GROUPCREATE = DOMAIN + '/corp/livecode/groupcreate' //活码分组新建
const URL_LIVECODE_GROUPDEL = DOMAIN + '/corp/livecode/groupdel' //05 活码分组删除
const URL_LIVECODE_GROUPRENAME = DOMAIN + '/corp/livecode/grouprename' //07 活码分组重命名
const URL_LIVECODE_CREATE = DOMAIN + '/corp/livecode/create' //新建渠道码
const URL_LIVECODE_DETAIL = DOMAIN + '/corp/livecode/detail' //获取单个活码的详情数据
const URL_LIVECODE_EDIT = DOMAIN + '/corp/livecode/edit' //渠道活码编辑
const URL_LIVECODE_DEL = DOMAIN + '/corp/livecode/del'//活码删除
const URL_LIVE_CODE_BAT_GROUP = DOMAIN + '/corp/livecode/batgroup' //活码批量分组
const URL_LICE_CODE_DOWN_LOAD = DOMAIN + '/corp/livecode/download' //下载单个活码
const URL_LIVE_CODE_GROUP_LIVE_CODE = DOMAIN + '/corp/livecode/grouplivecode' //04 活码分组列表详情
const URL_LIVE_CODE_STATS_SET = DOMAIN + '/corp/livecode/statsset'//13 活码集合数据
const URL_LIVE_CODE_STATS_SET_LIST = DOMAIN + '/corp/livecode/statssetlist' //13 活码集合数据列表
const URL_LIVE_CODE_NEW_ACTIVITY = DOMAIN + '/corp/livecode/newactivity'//获取最新创建的活码
const URL_LIVE_CODE_STATS_COMPARE = DOMAIN + '/corp/livecode/statscompare'//19 活码对比数据
const URL_LIVE_CODE_STATS_COMPARE_LIST = DOMAIN + '/corp/livecode/statscomparelist'//19 活码对比数据列表
const URL_LIVE_CODE_STATS_SET_TIMER_ANGE = DOMAIN + '/corp/livecode/statsset/timerange' //15 活码集合数据时段详情
const URL_LIVE_CODE_STATS_SET_MEMBER_DATA = DOMAIN + '/corp/livecode/statsset/memberdata'//17 活码集合数据成员客户详情

//引流加人链接
const URL_LINKS_ADDCUSTOMER_LINKLIST = DOMAIN + '/corp/externalLinks/addcustomer/linklist' // 引流加人活动列表
const URL_LINKS_ADDCUSTOMER_CREATE = DOMAIN + '/corp/externalLinks/addcustomer/create' // 新建引流加人活动
const URL_LINKS_ADDCUSTOMER_DEL = DOMAIN + '/corp/externalLinks/addcustomer/del' // 删除引流加人活动
const URL_LINKS_ADDCUSTOMER_EDIT = DOMAIN + '/corp/externalLinks/addcustomer/edit' // 编辑引流加人活动
const URL_LINKS_ADDCUSTOMER_DETAIL = DOMAIN + '/corp/externalLinks/addcustomer/detail' // 获取引流加人活动详情
const URL_LINKS_ADDCUSTOMER_NAMELIST = DOMAIN + '/corp/externalLinks/addcustomer/namelist' // 获取引流加人活动名称列表
const URL_LINKS_ADDCUSTOMER_STATSDATA = DOMAIN + '/corp/externalLinks/addcustomer/statsdata'// 获取引流加人活动统计数据
const URL_LINKS_ADDCUSTOMER_LIST = DOMAIN + '/corp/externalLinks/addcustomer/customerlist' // 获取引流加人活动客户添加情况
const URL_LINKS_ADDCUSTOMER_DAYDATA = DOMAIN + '/corp/externalLinks/addcustomer/dailydata'// 引流加人活动每日添加情况
//引流加群
const URL_LINKS_JOINGROUP_LIST = DOMAIN + '/corp/externalLinks/joingroup/linklist'//引流加群活动列表
const URL_LINKS_JOINGROUP_CREATE = DOMAIN + '/corp/externalLinks/joingroup/create'//新建引流加群活动
const URL_LINKS_JOINGROUP_EDIT = DOMAIN + '/corp/externalLinks/joingroup/edit'//编辑引流加群活动
const URL_LINKS_JOINGROUP_DEL = DOMAIN + '/corp/externalLinks/joingroup/del'//删除引流加群活动
const URL_LINKS_JOINGROUP_DETAIL = DOMAIN + '/corp/externalLinks/joingroup/detail'//引流加群活动详情
const URL_LINKS_JOINGROUP_NAME_LIST = DOMAIN + '/corp/externalLinks/joingroup/namelist'//引流加群活动名称列表
const URL_LINKS_JOINGROUP_STATS_DATA = DOMAIN + '/corp/externalLinks/joingroup/statsdata'//引流加群活动统计数据
const URL_LINKS_JOINGROUP_CUST_LIST = DOMAIN + '/corp/externalLinks/joingroup/customerlist'//引流加群活动客户添加情况
const URL_LINKS_JOINGROUP_DAY_LIST = DOMAIN + '/corp/externalLinks/joingroup/dailydata'//引流加群活动每日添加情况

//社群红包
const URL_GROUP_RED_ACTIVITY_CREATE = DOMAIN + '/corp/group/redpacket/create' //群红包创建
const URL_GROUP_RED_ACTIVITY_MODIFY = DOMAIN + '/corp/group/redpacket/modify' //群红包编辑
const URL_GROUP_RED_ACTIVITY_DETAIL = DOMAIN + '/corp/group/redpacket/detail' //群红包详情
const URL_GROUP_RED_ACTIVITY_LIST = DOMAIN + '/corp/group/redpacket/query' //群红包列表
const URL_GROUP_RED_ACTIVITY_PROMOTE_INFO = DOMAIN + '/corp/group/redpacket/promoteInfo' //活动推广
const URL_GROUP_RED_ACTIVITY_DELETE = DOMAIN + '/corp/group/redpacket/delete' //删除活动
const URL_GROUP_RED_ACTIVITY_OPEN = DOMAIN + '/corp/group/redpacket/turnOn' //开启活动
const URL_GROUP_RED_ACTIVITY_CLOSE = DOMAIN + '/corp/group/redpacket/turnOff' //关闭活动
const URL_GROUP_RED_CHANNEL_CREATE = DOMAIN + '/corp/group/redpacket/channel/create' //创建渠道
const URL_GROUP_RED_CHANNEL_EDIT = DOMAIN + '/corp/group/redpacket/channel/edit' //编辑渠道
const URL_GROUP_RED_CHANNEL_DETAIL = DOMAIN + '/corp/group/redpacket/channel/detail' //渠道详情
const URL_GROUP_RED_CHANNEL_LIST = DOMAIN + '/corp/group/redpacket/channel/query' //渠道列表
const URL_GROUP_RED_CHANNEL_PROMO_INFO = DOMAIN + '/corp/group/redpacket/channel/promoinfo' //渠道推广
const URL_GROUP_RED_CHANNEL_DELETE = DOMAIN + '/corp/group/redpacket/channel/delete' //渠道删除
const URL_GROUP_RED_CHANNEL_NAME_LIST = DOMAIN + '/corp/group/redpacket/channel/menulist' //渠道下拉列表
const URL_GROUP_RED_ACTIVITY_NAME_LIST = DOMAIN + '/corp/group/redpacket/namelist' //活动下拉列表
const URL_GROUP_RED_REPORT_STATS = DOMAIN + '/corp/group/redpacket/stats' //数据统计
const URL_GROUP_RED_CUSTOMER_LIST = DOMAIN + '/corp/group/redpacket/customerlist' //客户列表
const URL_GROUP_RED_GROUP_LIST = DOMAIN + '/corp/group/redpacket/groupstats' //群聊列表
const URL_GROUP_RED_INVITE_DETAIL = DOMAIN + '/corp/group/redpacket/invitedetail' //邀请详情
const URL_GROUP_RED_INVITE_LIST = DOMAIN + '/corp/group/redpacket/invitelist' //邀请列表
const URL_GROUP_RED_MASTER_LIST = DOMAIN + '/corp/group/redpacket/masterlist' //群主下拉列表

//消息订阅
const URL_MSG_SUBSCRIBE_GET_QRCODE = DOMAIN + '/msgsubs/getqrcode'
const URL_MSG_SUBSCRIBE_GET_SUBSFANS = DOMAIN + '/msgsubs/subsfans'
const URL_MSG_SUBSCRIBE_UN_SUBSCRIBE = DOMAIN + '/msgsubs/unsubscribe'
const URL_MSG_SUBSCRIBE_GET_SUBRADIO = DOMAIN + '/msgsubs/subsmsgradio'
const URL_MSG_SUBSCRIBE_OPEN_SUBMSG = DOMAIN + '/msgsubs/subsmsg'
const URL_MSG_SUBSCRIBE_OFF_SUBMSG = DOMAIN + '/msgsubs/unsubsmsg'
const URL_MSG_SUBSCRIBE_GET_PHONE_LIST = DOMAIN + '/msgsubs/phonenolist'
const URL_MSG_SUBSCRIBE_ADD_PHONE = DOMAIN + '/msgsubs/addphoneno'
const URL_MSG_SUBSCRIBE_EDIT_PHONE = DOMAIN + '/msgsubs/editphoneno'
const URL_MSG_SUBSCRIBE_DEL_PHONE = DOMAIN + '/msgsubs/delphoneno'
const URL_MSG_SUBSCRIBE_GET_SCANINFO = DOMAIN + '/msgsubs/getscaninfo'
const URL_MSG_SUBSCRIBE_EDIT_FANS_NAME = DOMAIN + '/msgsubs/editfansname'

const URL_FISSION_GROUPFISSION_GROUPMSG_DETAIL = DOMAIN + '/corp/groupfission/groupmsg/detail' //社群裂变群发
const URL_FISSION_GROUP_REDPACKET_GROUPMSG_DETAIL = DOMAIN + '/corp/group/redpacket/groupmsg/detail' //红包扩群群发
const URL_FISSION_LOTTERY_GROUPMSG_DETAIL = DOMAIN + '/corp/lottery/groupmsg/detail' //抽奖裂变群发

//群红包--新增的群聊管理
const URL_FISSION_GROUP_REDPACKET_ROOM_MANAGE = DOMAIN + '/corp/group/redpacket/groupstats' //群聊数据列表
const URL_FISSION_GROUP_REDPACKET_ROOM_EDIT_QRCODE = DOMAIN + '/corp/group/redpacket/modifyGroupQRCodeInfo' //修改群聊二维码
const URL_FISSION_GROUP_REDPACKET_ROOM_EDIT_ORDER = DOMAIN + '/corp/group/redpacket/modifyGroupOrder' //调整群聊顺序
//群裂变--新增的群聊管理
const URL_FISSION_CHAT_ROOM_MANAGE = DOMAIN + '/corp/groupfission/groupstats' //群聊数据列表
const URL_FISSION_CHAT_ROOM_EDIT_QRCODE = DOMAIN + '/corp/groupfission/modifyGroupQRCodeInfo' //修改群聊二维码
const URL_FISSION_CHAT_ROOM_EDIT_ORDER = DOMAIN + '/corp/groupfission/modifyGroupOrder' //调整群聊顺序

const doPost = (url, bodyType, bodyData, success, error, docatch) => {
    let fetchUtil = new FetchUtil();
    fetchUtil.init()
        .setUrl(url)
        .setMethod("POST")
        .setCookieCors()
        .setBodyType(bodyType)
        .setBody(bodyData)
        .dofetch()
        .then((msg) => {
            if (msg.respCode == 0) {
                if (success) {
                    success(msg.respMsg)
                }
            } else {
                if (error) {
                    error(msg)
                }
            }
        })
        .catch((msg) => {
            if (docatch) {
                docatch(msg)
            } else if (error) {
                error(msg)
            }
        })
};

const doGet = (url, success, error, docatch) => {
    let fetchUtil = new FetchUtil();
    fetchUtil.init()
        .setUrl(url)
        .setMethod("GET")
        .setCookieCors()
        .setBodyType('json')
        .dofetch()
        .then((msg) => {
            if (msg.respCode == 0) {
                if (success) {
                    success(msg.respMsg)
                }
            } else {
                if (error) {
                    error(msg)
                }
            }
        })
        .catch((msg) => {
            if (docatch) {
                docatch(msg)
            } else if (error) {
                error(msg)
            }
        })
};

class CorpApi {

    /**
     * 群裂变 调整群聊顺序
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupFissionRoomOrder(queryParam, bodyData, success, error) {
        let query = `?fissionId=${queryParam.fissionId}&groupId=${queryParam.groupId}`
        doPost(URL_FISSION_CHAT_ROOM_EDIT_ORDER + query, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 修改群聊二维码
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupFissionRoomQrCode(queryParam, bodyData, success, error) {
        let query = `?fissionId=${queryParam.fissionId}&groupId=${queryParam.groupId}`
        doPost(URL_FISSION_CHAT_ROOM_EDIT_QRCODE + query, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 群聊数据列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupFissionRoomList(queryParam, bodyData, success, error) {
        let query = `?fissionId=${queryParam.fissionId}&channelId=${queryParam.channelId}`
        doPost(URL_FISSION_CHAT_ROOM_MANAGE + query, 'json', bodyData, success, error)
    }

    /**
     * 群红包 调整群聊顺序
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupRedRoomOrder(queryParam, bodyData, success, error) {
        let query = `?fissionId=${queryParam.fissionId}&groupId=${queryParam.groupId}`
        doPost(URL_FISSION_GROUP_REDPACKET_ROOM_EDIT_ORDER + query, 'json', bodyData, success, error)
    }

    /**
     * 群红包 修改群聊二维码
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupRedRoomQrCode(queryParam, bodyData, success, error) {
        let query = `?fissionId=${queryParam.fissionId}&groupId=${queryParam.groupId}`
        doPost(URL_FISSION_GROUP_REDPACKET_ROOM_EDIT_QRCODE + query, 'json', bodyData, success, error)
    }

    /**
     * 群红包 群聊数据列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupRedRoomList(queryParam, bodyData, success, error) {
        let query = `?groupRedPacketId=${queryParam.groupRedPacketId}&channelId=${queryParam.channelId}`
        doPost(URL_FISSION_GROUP_REDPACKET_ROOM_MANAGE + query, 'json', bodyData, success, error)
    }

    /**
     * 社群裂变 群发详情
     * @param taskId
     * @param success
     * @param error
     */
    static getFissionGroupMsgDetail(taskId, success, error) {
        doGet(URL_FISSION_GROUPFISSION_GROUPMSG_DETAIL + `?taskId=${taskId}`, success, error)
    }

    /**
     * 红包扩群 群发详情
     * @param taskId
     * @param success
     * @param error
     */
    static getFissionGroupRedpacketDetail(taskId, success, error) {
        doGet(URL_FISSION_GROUP_REDPACKET_GROUPMSG_DETAIL + `?taskId=${taskId}`, success, error)
    }

    /**
     * 抽奖裂变 群发详情
     * @param taskId
     * @param success
     * @param error
     */
    static getFissionLotteryDetail(taskId, success, error) {
        doGet(URL_FISSION_LOTTERY_GROUPMSG_DETAIL + `?taskId=${taskId}`, success, error)
    }

    /**
     * 编辑订阅公众号客户名称
     * @param bodyData
     * @param success
     * @param error
     */
    static editMsgSubFansName(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_EDIT_FANS_NAME, 'json', bodyData, success, error)
    }

    /**
     * 获取订阅公众号扫码结果
     * @param key
     * @param success
     * @param error
     */
    static getMsgSubScanInfo(key, success, error) {
        doGet(URL_MSG_SUBSCRIBE_GET_SCANINFO + `?key=${key}`, success, error)
    }

    /**
     * 删除手机号
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteMsgSubPhone(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_DEL_PHONE, 'json', bodyData, success, error)
    }

    /**
     * 编辑手机号
     * @param bodyData
     * @param success
     * @param error
     */
    static editMsgSubPhone(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_EDIT_PHONE, 'json', bodyData, success, error)
    }

    /**
     * 添加手机号
     * @param bodyData
     * @param success
     * @param error
     */
    static addMsgSubPhone(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_ADD_PHONE, 'json', bodyData, success, error)
    }

    /**
     * 获取短信订阅手机号列表
     * @param success
     * @param error
     */
    static getMsgSubPhoneList(success, error) {
        doGet(URL_MSG_SUBSCRIBE_GET_PHONE_LIST, success, error)
    }

    /**
     * 取消消息订阅
     * @param bodyData
     * @param success
     * @param error
     */
    static offMsgSubCcribe(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_OFF_SUBMSG, 'json', bodyData, success, error)
    }

    /**
     * 开启消息订阅
     * @param bodyData
     * @param success
     * @param error
     */
    static openMsgSubCcribe(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_OPEN_SUBMSG, 'json', bodyData, success, error)
    }

    /**
     * 获取订阅消息开关列表
     * @param success
     * @param error
     */
    static getMsgSubRadioList(success, error) {
        doGet(URL_MSG_SUBSCRIBE_GET_SUBRADIO, success, error)
    }

    /**
     * 取消公众号订阅
     * @param bodyData
     * @param success
     * @param error
     */
    static unSubscribeMsg(bodyData, success, error) {
        doPost(URL_MSG_SUBSCRIBE_UN_SUBSCRIBE, 'json', bodyData, success, error)
    }

    /**
     * 获取订阅公众号客户列表
     * @param queryParam
     * @param success
     * @param error
     */
    static getMsgSubFansList(queryParam, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doGet(URL_MSG_SUBSCRIBE_GET_SUBSFANS + query, success, error)
    }

    /**
     *获取订阅公众号二维码
     * @param success
     * @param error
     */
    static getMsgSubQrcode(success, error) {
        doGet(URL_MSG_SUBSCRIBE_GET_QRCODE, success, error)
    }

    /**
     * 社群红包 群主下拉列表
     * @param id
     * @param success
     * @param error
     */
    static getGroupRedMasterList(id, success, error) {
        doGet(URL_GROUP_RED_MASTER_LIST + `?groupRedPacketId=${id}`, success, error)
    }

    /**
     * 社群红包 邀请详情中的列表
     * @param queryParam
     * @param success
     * @param error
     */
    static getGroupRedInviteList(queryParam, success, error) {
        let query = `?gfId=${queryParam.gfId}&pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doGet(URL_GROUP_RED_INVITE_LIST + query, success, error)
    }

    /**
     * 社群红包 邀请详情
     * @param id
     * @param success
     * @param error
     */
    static getGroupRedInviteDetail(id, success, error) {
        doGet(URL_GROUP_RED_INVITE_DETAIL + `?grfId=${id}`, success, error)
    }

    /**
     * 社群红包 群聊列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupRedGroupList(queryParam, bodyData, success, error) {
        let query = `?groupRedPacketId=${queryParam.groupRedPacketId}&channelId=${queryParam.channelId}`
        doPost(URL_GROUP_RED_GROUP_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 客户列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupRedCustomerList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_RED_CUSTOMER_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 渠道下拉列表
     * @param id
     * @param success
     * @param error
     */
    static getGroupRedChannelNameList(id, success, error) {
        doGet(URL_GROUP_RED_CHANNEL_NAME_LIST + `?groupRedPacketId=${id}`, success, error)
    }

    /**
     * 社群红包 数据统计
     * @param queryParam
     * @param success
     * @param error
     */
    static getGroupRedReportStats(queryParam, success, error) {
        let query = `?groupRedPacketId=${queryParam.groupRedPacketId}&channelId=${queryParam.channelId}`
        doGet(URL_GROUP_RED_REPORT_STATS + query, success, error)
    }

    /**
     * 社群红包 渠道删除
     * @param channelId
     * @param success
     * @param error
     */
    static deleteGroupRedChannel(channelId, success, error) {
        doGet(URL_GROUP_RED_CHANNEL_DELETE + `?channelId=${channelId}`, success, error)
    }

    /**
     * 社群红包 渠道推广
     * @param channelId
     * @param success
     * @param error
     */
    static getGroupRedChannelPromoteInfo(channelId, success, error) {
        doGet(URL_GROUP_RED_CHANNEL_PROMO_INFO + `?channelId=${channelId}`, success, error)
    }

    /**
     * 社群红包 编辑渠道
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupRedChannel(bodyData, success, error) {
        doPost(URL_GROUP_RED_CHANNEL_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 渠道详情
     * @param channelId
     * @param success
     * @param error
     */
    static getGroupRedChannelDetail(channelId, success, error) {
        doGet(URL_GROUP_RED_CHANNEL_DETAIL + `?channelId=${channelId}`, success, error)
    }

    /**
     * 社群红包 创建渠道
     * @param bodyData
     * @param success
     * @param error
     */
    static createGroupRedChannel(bodyData, success, error) {
        doPost(URL_GROUP_RED_CHANNEL_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 关闭活动
     * @param id
     * @param success
     * @param error
     */
    static closeGroupRedActivity(id, success, error) {
        doGet(URL_GROUP_RED_ACTIVITY_CLOSE + `?groupRedPacketId=${id}`, success, error)
    }

    /**
     * 社群红包 开启活动
     * @param id
     * @param success
     * @param error
     */
    static openGroupRedActivity(id, bodyData, success, error) {
        doPost(URL_GROUP_RED_ACTIVITY_OPEN + `?groupRedPacketId=${id}`, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 删除活动
     * @param id
     * @param success
     * @param error
     */
    static deleteGroupRedActivity(id, success, error) {
        doGet(URL_GROUP_RED_ACTIVITY_DELETE + `?groupRedPacketId=${id}`, success, error)
    }

    /**
     * 社群红包 活动推广
     * @param id
     * @param success
     * @param error
     */
    static getGroupRedPromoteInfo(id, success, error) {
        doGet(URL_GROUP_RED_ACTIVITY_PROMOTE_INFO + `?groupRedPacketId=${id}`, success, error)
    }

    /**
     * 社群红包 红包详情
     * @param id
     * @param success
     * @param error
     */
    static getGroupRedDetail(id, success, error) {
        doGet(URL_GROUP_RED_ACTIVITY_DETAIL + `?groupRedPacketId=${id}`, success, error)
    }

    /**
     * 社群红包 红包编辑
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupRed(bodyData, success, error) {
        doPost(URL_GROUP_RED_ACTIVITY_MODIFY, 'json', bodyData, success, error)
    }

    /**
     *社群红包 活动列表
     * @param queryData
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupRedList(queryData, bodyData, success, error) {
        let query = `?pageNum=${queryData.pageNum}&pageSize=${queryData.pageSize}`
        doPost(URL_GROUP_RED_ACTIVITY_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 红包创建
     * @param bodyData
     * @param success
     * @param error
     */
    static createGroupRed(bodyData, success, error) {
        doPost(URL_GROUP_RED_ACTIVITY_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 社群红包 活动下拉列表
     * @param success
     * @param error
     */
    static getGroupRedNamelist(success, error) {
        doGet(URL_GROUP_RED_ACTIVITY_NAME_LIST, success, error)
    }

    /**
     * 社群红包 渠道列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupRedChannleList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GROUP_RED_CHANNEL_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 引流加群活动每日添加情况
     * @param linkId
     * @param success
     * @param error
     */
    static getLinkGroupDailyList(queryParam, success, error) {
        let query = `?linkId=${queryParam.linkId}&pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doGet(URL_LINKS_JOINGROUP_DAY_LIST + query, success, error)
    }

    /**
     * 引流加群活动客户添加情况
     * @param queryParam
     * @param success
     * @param error
     */
    static getLinkGroupCustList(queryParam, success, error) {
        let query = `?linkId=${queryParam.linkId}&pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doGet(URL_LINKS_JOINGROUP_CUST_LIST + query, success, error)
    }

    /**
     * 引流加群活动统计数据
     * @param linkId
     * @param success
     * @param error
     */
    static getLinkGroupStatsData(linkId, success, error) {
        doGet(URL_LINKS_JOINGROUP_STATS_DATA + `?linkId=${linkId}`, success, error)
    }

    /**
     * 引流加群活动名称列表
     * @param success
     * @param error
     */
    static getLinkGroupNameList(success, error) {
        doGet(URL_LINKS_JOINGROUP_NAME_LIST, success, error)
    }

    /**
     * 编辑引流加群活动
     * @param bodyData
     * @param success
     * @param error
     */
    static linkGroupEdit(bodyData, success, error) {
        doPost(URL_LINKS_JOINGROUP_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 引流加群活动详情
     * @param linkId
     * @param success
     * @param error
     */
    static getLinkGroupDetail(linkId, success, error) {
        doGet(URL_LINKS_JOINGROUP_DETAIL + `?linkId=${linkId}`, success, error)
    }

    /**
     * 删除引流加群活动
     * @param linkId
     * @param success
     * @param error
     */
    static linkGroupDelete(linkId, success, error) {
        doPost(URL_LINKS_JOINGROUP_DEL + `?linkId=${linkId}`, 'json', '', success, error)
    }

    /**
     * 新建引流加群活动
     * @param bodyData
     * @param success
     * @param error
     */
    static linkGroupCreate(bodyData, success, error) {
        doPost(URL_LINKS_JOINGROUP_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 引流加群活动列表
     * @param queryParam
     * @param success
     * @param error
     */
    static getJoinGroupList(queryParam, success, error) {
        let query = `?name=${queryParam.name}&pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doGet(URL_LINKS_JOINGROUP_LIST + query, success, error)
    }

    /**
     * 引流加人活动每日添加情况
     * @param queryParam
     * @param success
     * @param error
     */
    static getAddCostomeDayData(queryParam, success, error) {
        let query = `?linkId=${queryParam.linkId}&pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doGet(URL_LINKS_ADDCUSTOMER_DAYDATA + query, success, error)
    }

    /**
     * 获取引流加人活动统计数据
     * @param linkId
     * @param success
     * @param error
     */
    static getAddCustomerStatusData(linkId, success, error) {
        doGet(URL_LINKS_ADDCUSTOMER_STATSDATA + `?linkId=${linkId}`, success, error)
    }

    /**
     * 获取引流加人活动客户添加情况
     * @param queryParam
     * @param success
     * @param error
     */
    static getAddCustomerList(queryParam, success, error) {
        let query = `?linkId=${queryParam.linkId}&pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doGet(URL_LINKS_ADDCUSTOMER_LIST + query, success, error)
    }

    /**
     * 获取引流加人活动名称列表
     * @param success
     * @param error
     */
    static getAddCustomerNameList(success, error) {
        doGet(URL_LINKS_ADDCUSTOMER_NAMELIST, success, error)
    }

    /**
     * 编辑引流加人活动
     * @param bodyData
     * @param success
     * @param error
     */
    static linkAddCustomerEdit(bodyData, success, error) {
        doPost(URL_LINKS_ADDCUSTOMER_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 获取引流加人活动详情
     * @param linkId
     * @param success
     * @param error
     */
    static getAddCustomerLinkDetail(linkId, success, error) {
        doGet(URL_LINKS_ADDCUSTOMER_DETAIL + `?linkId=${linkId}`, success, error)
    }

    /**
     * 删除引流加人活动
     * @param linkId
     * @param success
     * @param error
     */
    static linkAddCustomerDel(linkId, success, error) {
        doPost(URL_LINKS_ADDCUSTOMER_DEL + `?linkId=${linkId}`, 'json', '', success, error)
    }

    /**
     * 新建引流加人活动
     * @param bodyData
     * @param success
     * @param error
     */
    static linkAddCustomerCreate(bodyData, success, error) {
        doPost(URL_LINKS_ADDCUSTOMER_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 引流加人活动列表
     * @param queryData
     * @param success
     * @param error
     */
    static getAddCustomerLinkList(queryData, success, error) {
        let query = `?name=${queryData.name}&pageNum=${queryData.pageNum}&pageSize=${queryData.pageSize}`
        doGet(URL_LINKS_ADDCUSTOMER_LINKLIST + query, success, error)
    }

    /**
     * 红包 邀请详情客户列表
     * @param queryParam
     * @param success
     * @param error
     */
    static getRedpacketInviteList(queryParam, success, error) {
        let query = `?rfId=${queryParam.rfId}&pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doGet(URL_GET_REDPACKET_INVITE_LIST + query, success, error)
    }

    /**
     * 红包 所属成员列表
     * @param redPacketId
     * @param success
     * @param error
     */
    static getRedpacketMember(redPacketId, success, error) {
        doGet(URL_GET_REDPACKET_MEMBER_LIST + `?redPacketId=${redPacketId}`, success, error)
    }

    /**
     * 红包 邀请详情
     * @param rfId
     * @param success
     * @param error
     */
    static getRedpacketInviteDetail(rfId, success, error) {
        doGet(URL_GET_REDPACKET_INVITE_DETAIL + `?rfId=${rfId}`, success, error)
    }

    /**
     *  红包 数据统计的客户列表
     * @param queryParam
     * @param boddyData
     * @param success
     * @param error
     */
    static getRedpacketCustomerList(queryParam, boddyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GET_REDPACKET_CUSTOMER_LIST + query, 'json', boddyData, success, error)
    }

    /**
     * 红包 渠道下拉列表
     * @param redPacketId
     * @param success
     * @param error
     */
    static getRedpacketChannelNameList(redPacketId, success, error) {
        doGet(URL_GET_REDPACKET_CHANNEL_MENULIST + `?redPacketId=${redPacketId}`, success, error)
    }

    /**
     *  红包 数据统计
     * @param queryParam
     * @param success
     * @param error
     */
    static getRedpacketReport(queryParam, success, error) {
        let query = `?redPacketId=${queryParam.redPacketId}&channelId=${queryParam.channelId}`
        doGet(URL_GET_REDPACKET_REPORT + query, success, error)
    }

    /**
     * 红包 活动下拉列表
     * @param success
     * @param error
     */
    static getRedpacketNamelist(success, error) {
        doGet(URL_GET_REDPACKET_ACTIVITY_NAME_LIST, success, error)
    }

    /**
     * 渠道推广
     * @param channelId
     * @param success
     * @param error
     */
    static getRedpacketChannelPromoinfo(channelId, success, error) {
        doGet(URL_GET_REDPACKET_CHANNEL_PROMOINFO + `?channelId=${channelId}`, success, error)
    }

    /**
     * 红包 渠道详情
     * @param channelId
     * @param success
     * @param error
     */
    static getRedpacketChannelDetail(channelId, success, error) {
        doGet(URL_GET_REDPACKET_CHANNEL_DETAIL + '?channelId=' + channelId, success, error)
    }

    /**
     * 红包 修改渠道
     * @param bodyData:{channelId,channelName}
     * @param success
     * @param error
     */
    static editRedpacketChannel(bodyData, success, error) {
        doPost(URL_EDIT_REDPACKET_CHANNEL, 'json', bodyData, success, error)
    }

    /**
     * 红包 渠道删除
     * @param channelId
     * @param success
     * @param error
     */
    static deleteRedpacketChannel(channelId, success, error) {
        doGet(URL_DELETE_REDPACKET_CHANNEL + '?channelId=' + channelId, success, error)
    }

    /**
     * 红包 创建渠道
     * @param bodyData:{ redPacketId,channelName }
     * @param success
     * @param error
     */
    static createRedpacketChannel(bodyData, success, error) {
        doPost(URL_CREATE_REDPACKET_CHANNEL, 'json', bodyData, success, error)
    }

    /**
     * 红包 渠道列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getRedpacketChannleList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GET_REDPACKET_CHANNEL_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 红包 活动编辑
     * @param bodyData
     * @param sucess
     * @param error
     */
    static editRedpacketActivity(bodyData, success, error) {
        doPost(URL_EDIT_REDPACKET_ACTIVITY, 'json', bodyData, success, error)
    }

    static getRedpacketDetail(redPacketId, success, error) {
        doGet(URL_GET_REDPACKET_ACTIVITY_DETAIL + `?redPacketId=${redPacketId}`, success, error)
    }

    /**
     *  群发消息创建
     * @param bodyData
     * @param success
     * @param error
     */
    static createRedpacketGroupSend(bodyData, success, error) {
        doPost(URL_CREATE_REDPACKET_SEND, 'json', bodyData, success, error)
    }

    /**
     * 群发详情
     * @param redPacketId
     * @param success
     * @param error
     */
    static getRedpacketGroupSend(taskId, success, error) {
        doGet(URL_GET_REDPACKET_SEND_DETAIL + `?taskId=${taskId}`, success, error)
    }

    /**
     * 删除活动
     * @param redPacketId
     * @param success
     * @param error
     */
    static deleteRedpacketActivity(redPacketId, success, error) {
        doGet(URL_DELETE_REDPACKET_ACTIVITY + `?redPacketId=${redPacketId}`, success, error)
    }

    /**
     * 开启活动
     * @param redPacketId
     * @param bodyData
     * @param success
     * @param error
     */
    static openRedpacketActivity(redPacketId, bodyData, success, error) {
        doPost(URL_OPEN_REDPACKET_ACTIVITY + `?redPacketId=${redPacketId}`, 'json', bodyData, success, error)
    }

    /**
     * 关闭活动
     * @param redPacketId
     * @param success
     * @param error
     */
    static closeRedpacketActivity(redPacketId, success, error) {
        doGet(URL_CLOSE_REDPACKET_ACTIVITY + `?redPacketId=${redPacketId}`, success, error)
    }

    /**
     * 红包活动 推广
     * @param redPacketId
     * @param success
     * @param error
     */
    static getRedpacketPromoinfo(redPacketId, success, error) {
        doGet(URL_GET_REDPACKET_PROMOINFO + `?redPacketId=${redPacketId}`, success, error)
    }

    /**
     * 红包活动列表
     * @param queryParam
     * @param bodyData
     * @param success
     * @param error
     */
    static getRedpacketList(queryParam, bodyData, success, error) {
        let query = `?pageSize=${queryParam.pageSize}&pageNum=${queryParam.pageNum}`
        doPost(URL_GET_REDPACKET_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 创建红包活动
     * @param bodyData
     * @param success
     * @param error
     */
    static createRedpacket(bodyData, success, error) {
        doPost(URL_CREATE_REDPACKET_ACTIVITY, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的活动管理的列表数据
     * @param pageSize
     * @param pageNum
     * @param bodyData{status:0 全部 1进行中 2已经结束,taskName:活动名称}
     */
    static getLotteryQuery(pageSize, pageNum, bodyData, success, error) {
        doPost(URL_GET_LOTTERY_QUERY + '?pageSize=' + pageSize + '&pageNum=' + pageNum, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的活动下拉列表
     */
    static getLotteryNameList(success, error) {
        doGet(URL_GET_LOTTERY_NAME_LIST, success, error)
    }

    /**
     * 抽奖裂变的数据统计的渠道下拉列表
     */
    static getLotteryChannelMenuList(lotteryId, success, error) {
        doGet(URL_GET_LOTTERY_CHANNEL_MENULIST + '?lotteryId=' + lotteryId, success, error)
    }

    /**
     * 抽奖裂变的渠道的列表数据
     * @param pageSize
     * @param pageNum
     * @param bodyData{lotteryId，任务名称id,channelName:渠道名称}
     */
    static getLotteryChannelQuery(pageSize, pageNum, bodyData, success, error) {
        doPost(URL_GET_LOTTERY_CHANNEL_QUERY + '?pageSize=' + pageSize + '&pageNum=' + pageNum, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的新建活动
     * @param bodyData
     */
    static getLotteryCreate(bodyData, success, error) {
        doPost(URL_GET_LOTTERY_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的详情
     * @param lotteryId   活动的ID
     */
    static getLotteryDetail(lotteryId, success, error) {
        doGet(URL_GET_LOTTERY_DETAIL + '?lotteryId=' + lotteryId, success, error)
    }

    /**
     * 抽奖裂变的编辑
     * @param bodyData {lotteryId}  活动的ID
     */
    static getLotteryModify(bodyData, success, error) {
        doPost(URL_GET_LOTTERY_MODIFY, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的删除活动
     * @param lotteryId   活动的ID
     */
    static getLotteryDelete(lotteryId, success, error) {
        doGet(URL_GET_LOTTERY_DELETE + '?lotteryId=' + lotteryId, success, error)
    }

    /**
     * 抽奖裂变的推广
     * @param lotteryId   活动的ID
     */
    static getLotteryPromote(lotteryId, success, error) {
        doGet(URL_Get_LOTTERY_PROMOTE + '?lotteryId=' + lotteryId, success, error)
    }

    /**
     * 抽奖裂变的关闭活动
     * @param lotteryId   活动的ID
     */
    static getLotteryTurnoff(lotteryId, success, error) {
        doGet(URL_GET_LOTTERY_TURNOFF + '?lotteryId=' + lotteryId, success, onerror)
    }

    /**
     * 抽奖裂变的开启活动
     * @param lotteryId   活动的ID
     */
    static getLotteryTurnon(lotteryId, bodyData, success, error) {
        doPost(URL_GET_LOTTERY_TURNON + '?lotteryId=' + lotteryId, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的数据统计的数据
     * @param lotteryId   活动的ID  channelId 渠道ID
     */
    static getLotteryStats(params, success, error) {
        let query = '?lotteryId=' + params.lotteryId + '&channelId=' + params.channelId
        doGet(URL_GET_LOTTERY_STATS + query, success, error)
    }

    /**
     * 抽奖裂变的数据统计的所属成员下拉列表
     * @param lotteryId   活动的ID
     */
    static getLotteryMemberList(lotteryId, success, error) {
        doGet(URL_GET_LOTTERY_MEMBER_LIST + '?lotteryId=' + lotteryId, success, error)
    }

    /**
     * 抽奖裂变的数据统计的表格数据
     * @param pageSize   pageNum   bodyData
     */
    static getLotteryCustomerList(pageSize, pageNum, bodyData, success, error) {
        doPost(URL_GET_LOTTERY_CUSTOMER_LIST + '?pageSize=' + pageSize + '&pageNum=' + pageNum, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的数据统计的查看客户抽奖详情
     * @param pageSize   pageNum   lfId
     */
    static getLotteryCustomerReceiveList(pageSize, pageNum, lfId, success, error) {
        doGet(URL_GET_LOTTERY_CUSTOMER_RECEIVE_LIST + '?pageSize=' + pageSize + '&pageNum=' + pageNum + '&lfId=' + lfId, success, error)
    }

    /**
     * 抽奖裂变的数据统计的邀请详情数据
     * @param pageSize   pageNum   lfId
     */
    static getLotteryInvitDetail(lfId, success, error) {
        doGet(URL_GET_LOTTERY_INVIT_DETAIL + '?lfId=' + lfId, success, error)
    }

    /**
     * 抽奖裂变的数据统计的邀请客户列表
     * @param pageSize   pageNum   lfId
     */
    static getLotteryInviteList(pageSize, pageNum, lfId, success, error) {
        doGet(URL_GET_LOTTERY_INVITE_LIST + '?pageSize=' + pageSize + '&pageNum=' + pageNum + '&lfId=' + lfId, success, error)
    }

    /**
     * 抽奖裂变的创建渠道
     * @param bodyData
     */
    static getLotteryChannelCreate(bodyData, success, error) {
        doPost(URL_GET_LOTTERY_CHANNEL_CREATE, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的编辑渠道
     * @param bodyData
     */
    static getLotteryChannelModify(bodyData, success, error) {
        doPost(URL_GET_LOTTERY_CHANNEL_MODIFY, 'json', bodyData, success, error)
    }

    /**
     * 抽奖裂变的渠道详情
     * @param channelId
     */
    static getLotteryChannelDetail(channelId, success, error) {
        doGet(URL_GET_LOTTERY_CHANNEL_DETAIL + '?channelId=' + channelId, success, error)
    }

    /**
     * 抽奖裂变的渠道推广
     * @param channelId
     */
    static getLotteryChannelPromoinfo(channelId, success, error) {
        doGet(URL_GET_LOTTERY_CHANNEL_PROMOINFO + '?channelId=' + channelId, success, error)
    }

    /**
     * 抽奖裂变的删除渠道
     * @param channelId
     */
    static getLotteryChannelDelete(channelId, success, error) {
        doGet(URL_GET_LOTTERY_CHANNEL_DELETE + '?channelId=' + channelId, success, error)
    }

    /**
     * 抽奖裂变的兑换码
     * @param channelId
     */
    static getLotteryRedeemCodeList(lotteryId, success, error) {
        doGet(URL_GET_LOTTERY_REDEEM_CODE_LIST + '?lotteryId=' + lotteryId, success, error)
    }

    /**
     * 系统登录
     * @param params
     * @param success
     * @param error
     */
    static userLogin(params, success, error, docatch) {
        doPost(URL_USER_LOGIN, 'json', params, success, error, docatch);
    }

    /**
     * 用户注册
     * @param params
     * @param success
     * @param error
     */
    static userRegister(params, success, error, docatch) {
        doPost(URL_USER_REGISTER, 'json', params, success, error, docatch);
    }

    /**
     * 发送用户验证码
     * @param params
     * @param success
     * @param error
     * @param docatch
     */
    static userCaptcha(params, success, error, docatch) {
        doPost(URL_USER_CAPTCHA, 'json', params, success, error, docatch);
    }

    /**
     * 用户重置密码
     * @param params
     * @param success
     * @param error
     * @param docatch
     */
    static userFindPass(params, success, error, docatch) {
        doPost(URL_USER_FINDPASS, 'json', params, success, error, docatch);
    }

    /**
     * 删除营销活动核销员
     * @param checkerId
     * @param success
     * @param error
     */
    static delMarketOrderChecker(checkerId, success, error) {
        doPost(URL_DEL_MARKET_ORDER_CHECKER, 'json', {checkerId: checkerId}, success, error);
    }

    /**
     * 获取核销员列表
     * @param pageNum
     * @param pageSize
     * @param success
     * @param error
     */
    static getMarketOrderCheckerList(pageNum, pageSize, success, error) {
        doGet(URL_GET_MARKET_ORDER_CHECKER_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, success, error)
    }

    static getCustomerTagList(success, error) {
        doPost(URL_GET_CUSTOMER_TAG_LIST, success, error);
    }

    /**
     * 获取标签组
     * @param tagGroupName String
     * @param tagList Array
     */
    static getCustomerTagGroup(params, success, error) {
        doPost(URL_GET_ADD_TAG_GROUP, 'json', params, success, error)
    }

    // static getCustomerTagList(success, error) {
    //     doPost(URL_GET_CUSTOMER_TAG_LIST, success, error);
    // }

    /**
     * 获取一元解锁推广信息
     * @param boostId
     * @param success
     * @param error
     */
    static getMarketPzUnlockPromotoInfo(boostId, success, error) {
        doPost(URL_GET_MARKET_PZUNLOCK_PROMOTOINFO, 'json', {boostId: boostId}, success, error);
    }

    /**
     * 获取一元解锁活动绑定的兑换码礼品
     * @param boostId  活动ID
     * @param success
     * @param error
     */
    static getBoostRedeemcodeBinding(boostId, success, error) {
        doGet(URL_GET_BOOST_REDEEMCODE_BINDING + '?boostId=' + boostId, success, error)
    }

    /**
     * 获取客户标签列表
     * @param tagName 标签名
     * @param success
     * @param error
     */
    static getCustomerTagList(tagName, success, error) {
        let queryParam = tagName == null ? '' : '?tagName=' + tagName
        doGet(URL_GET_TAG_LIST + queryParam, success, error)
    }

    /**
     * 编辑标签组
     * @param {*} params 
     * @param {*} success 
     * @param {*} error 
     */
    static updateTagGroup(params, success, error) {
        doPost(URL_GET_COMPILE_TAG_GROUP, 'json', params, success, error)
    }

    /**
     * 标签组排序,(上移,下移)
     * @param tagGroupId
     * @param success
     * @param error
     */
    static updateTagOrder(tagGroupId, success, error) {
        doPost(URL_UPDATE_TAG_ORDER, 'json', {tagGroupId}, success, error);
    }

    /**
     * 获取客户列表
     * @param {*} success
     * @param {*} error
     * @param {*} pageNum
     * @param {*} pageSize
     */
    static getCustomerList(params, bodyData, success, error) {
        let pageNum = params.pageNum;
        let pageSize = params.pageSize
        doPost(URL_POST_CRM_CUSTOMERLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     * 获取分销活动名称列表，多用于分销活动下拉筛选
     */
    static getMarketDistriActivityNameList(success, error) {
        doGet(URL_GET_MARKET_DISTRI_ACTIVITY_NAMELIST, success, error)
    }

    /**
     * 获取分销活动渠道列表
     * @param pageNum
     * @param pageSize
     * @param success
     * @param error
     */
    static getMarketDistriChannelList(bodyParams, pageNum, pageSize, success, error) {
        doPost(URL_GET_MARKET_DISTRI_CHANNEL_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyParams, success, error)
    }

    /**
     * 删除分销渠道
     * @param channelId
     * @param success
     * @param error
     */
    static deleteMarketChannel(channelId, success, error) {
        doGet(URL_DEL_MARKET_DISTRI_CHANNEL + channelId, success, error);
    }

    /**
     * 获取分销渠道推广二维码等信息
     * @param channelId
     * @param success
     * @param error
     */
    static getMarketDistriChannelPromoInfo(channelId, success, error) {
        doGet(URL_GET_MARKET_DISTRI_CHANNEL_PROMOINFO + channelId, success, error);
    }

    /**
     * 添加标签
     * @param param
     * @param success
     * @param error
     */
    static addTag(param, success, error) {
        doPost(URL_ADD_TAG, 'json', param, success, error);
    }


    /**
     * 获取黑名单列表
     * @param {*} success
     * @param {*} error
     */
    static getCrmBlackList(params, success, error) {
        doGet(URL_GET_CRM_BLACKLIST + '?pageNum=' + params.pageNum + '&pageSize=' + params.pageSize + '&customerName=' + params.customerName, success, error)
    }

    /**
     * 拉黑客户
     * @param crmId
     * @param reason
     * @param success
     * @param error
     */
    static pullCrmBlack(crmId, reason, success, error) {
        doPost(URL_PULL_CRM_BLACK, 'json', {crmId: crmId, reason: reason}, success, error)
    }


    /*
     * 删除黑名单接口
     * params curmId 用户id
     * success
     * error
     * */
    static removeBlackList(crmId, success, error) {
        doPost(URL_REMOVE_BLACK_LIST, 'json', {crmId}, success, error)
    }

    /*
     * 同步成员接口
     * success
     * error
     * */
    static getMemberSync(success,error){
        doGet(URL_GET_MEMBER_SYNC,success,error)
    }

    /**
     * 新加的获取添加成员的接口
     * @param pageNum
     * @param pageSize
     * @param bodyDATA
     * @param success
     * @param error
     */
    static getCorpCrmCorpiserPage(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_CORP_CRM_CORPUSER_PAGE + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     * 活动列表
     * @param pageNum
     * @param pageSize
     * @param taskName
     * @param status
     * @param success
     * @param error
     */
    static getActivityList(pageNum, pageSize, taskName, status, taskType, success, error) {
        let query = '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&taskName=' + taskName + '&status=' + status + '&taskType=' + taskType
        doGet(URL_GET_ACTIVITY_LIST + query, success, error)
    }

    /**
     * 同步标签
     * @param success
     * @param error
     */
    static syncTag(success, error) {
        doGet(URL_SYNC_TAG, success, error)
    }

    /**
     * 批量打标签
     * @param bodyData
     * @param success
     * @param error
     */
    static addBatTag(bodyData, success, error) {
        doPost(URL_ADD_BATTAG, 'json', bodyData, success, error)
    }

    /**
     * 批量删除标签
     * @param bodyData
     * @param success
     * @param error
     */
    static deleteTags(bodyData, success, error) {
        doPost(URL_DELETE_TAGS, 'json', bodyData, success, error)
    }

    /**
     *获取渠道列表
     * @param params
     * @param taskId 任务ID，默认0全部
     * @param channelName 渠道名称，模糊查处
     * @param success
     * @param error
     */
    static getChannelList(params, bodyData, success, error) {
        let query = '?pageNum=' + params.pageNum + '&pageSize=' + params.pageSize
        let bodyParams = {taskId: bodyData.taskId, channelName: bodyData.channelName}
        doPost(URL_GET_CHANNEL_LIST + query, 'json', bodyParams, success, error)
    }

    /**
     * 获取渠道下拉列表
     * @param taskId
     */
    static getChannelMenuList(taskId, success, error) {
        doGet(URL_GET_CHANNEL_MENU_LIST + '?taskId=' + taskId, success, error)
    }

    /**
     * 新建渠道
     * @param bodyData ｛taskId，channelName｝
     * @param success
     * @param error
     */
    static createNewChannel(bodyData, success, error) {
        let bodyParams = {taskId: bodyData.taskId, channelName: bodyData.channelName}
        doPost(URL_CREATE_CHANNEL, 'json', bodyParams, success, error)
    }

    /**
     * 获取可用公众号
     * @param success
     * @param error
     */
    static gainUsableOfficial(success, error) {
        doGet(URL_GET_ACTIVITY_USABLE_OFFICIAL, success, error)
    }

    /**
     * 获取消息模板列表
     * @param appId
     * @param success
     * @param error
     */

    static getMsgTempolateList(appId, success, error) { //模板消息公用
        doGet(URL_GET_SUBS_MAG_TEMPLATE_LIST + '?appId=' + appId, success, error)
    }

    /**
     * 删除渠道
     * @param channelId
     * @param success
     * @param error
     */
    static deleteChannelById(channelId, success, error) {
        doGet(URL_DELETE_CHANNEL + '?channelId=' + channelId, success, error)
    }

    /**
     * 渠道推广
     * @param channelId
     * @param success
     * @param error
     */
    static getChannelPromoinfo(channelId, success, error) {
        doGet(URL_GET_CHANNEL_PROMOINFO + '?channelId=' + channelId, success, error)
    }

    /**
     * 编辑渠道
     * @param bodyData
     * @param success
     * @param error
     */
    static editChannelInfo(bodyData, success, error) {
        doPost(URL_EDIT_CHANNEL_INFO, 'json', bodyData, success, error)
    }

    /**
     * 获取渠道详情
     * @param channelId
     * @param success
     * @param error
     */
    static getChannelInfo(channelId, success, error) {
        doGet(URL_GET_CHANNEL_INFO + '?channelId=' + channelId, success, error)
    }

    /**
     * 所属成员下拉列表
     * @param taskId
     * @param success
     * @param error
     */
    static getTaskMemberlist(taskId, success, error) {
        doGet(URL_GET_TASK_MEMBER_LIST + `?taskId=${taskId}`, success, error)
    }

    /**
     * 获取 活动名称 列表
     * @param success
     * @param error
     */
    static getActivityNameList(success, error) {
        doGet(URL_GET_ACTIVITY_NAME_LIST, success, error)
    }

    /**
     * 活动数据  (每一条的)
     * @param params
     * @param success
     * @param error
     */
    static getActivityStats(params, success, error) {
        let query = '?taskId=' + params.taskId + '&channelId=' + params.channelId
        doGet(URL_GET_TASK_ACTIVITY_STATS + query, success, error)
    }

    /**
     * 获取 活动推广信息
     * @param taskId
     * @param success
     * @param error
     */
    static getActivityPromoinfo(taskId, success, error) {
        let query = '?taskId=' + taskId
        doGet(URL_GET_ACTIVITY_PROMOINFO + query, success, error)
    }


    /**
     * 获取客服成员列表
     * @param success
     * @param error
     */
    static getCorpUserList(success, error) {
        doGet(URL_GET_GAIN_SERVICE_MEMBER_LIST, success, error)
    }

    /**
     * 任务宝任务宝活动管理页面新建活动
     * @param success
     * @param error
     */
    static getEnterpriseMicroTaskTreasureNewActivities(bodyData, success, error) {
        doPost(URL_GET_ENTERPRISE_MICRO_TASK_TREASURE_NEW_ACTIVITIES, 'json', bodyData, success, error)
    }

    /**
     * 任务宝任务宝活动管理页面编辑活动
     * @param success
     * @param error
     */
    static getEnterpriseMicroTaskTreasureEditingActivity(bodyData, success, error) {
        doPost(URL_GET_ENTERPRISE_MICRO_TASK_TREASURE_EDITING_ACTIVITY, 'json', bodyData, success, error)
    }

    /**
     * 任务宝任务宝活动管理页面获取活动信息
     * @taskId 活动Id
     * @param success
     * @param error
     */
    static getEnterpriseObtainActivityInformation(taskId, success, error) {
        doGet(URL_GET_ENTERPRISE_OBTAIN_ACTIVITY_INFORMATION + '?taskId=' + taskId, success, error)
    }

    /**
     * 任务宝任务宝活动管理页面删除活动
     * @taskId 活动Id
     * @param success
     * @param error
     */
    static getEnterpriseObtainDeleteActivity(taskId, success, error) {
        doPost(URL_GET_ENTERPRISE_OBTAIN_DELETE_ACTIVITY, 'json', taskId, success, error)
    }

    /**
     * 任务宝任务宝活动绑定的兑换码礼品
     * @taskId 活动Id
     * @param success
     * @param error
     */
    static getTaskActivityRedeemcodeBinding(taskId, success, error) {
        doGet(URL_GET_TASKACTIVITY_REDEEMCODE_BINDING + '?taskId=' + taskId, success, error)
    }

    /**
     * 获取系统授权的公众号列表
     * @param success
     * @param error
     */
    static getSubsOAList(success, error) {
        doGet(URL_GET_SUBS_OALIST, success, error)
    }

    /**
     * 获取公众号授权地址
     * @param success
     * @param error
     */
    static getSubsAuthUrl(success, error) {
        doGet(URL_GET_SUBS_AUTHURL, success, error)
    }

    /**
     * 任务宝任务宝活动管理页面关闭活动
     * @taskId 活动Id
     * @param success
     * @param error
     */
    static getEnterpriseObtainCloseActivity(taskId, success, error) {
        doPost(URL_GET_ENTERPRISE_OBTAIN_CLOSE_ACTIVITY, 'json', taskId, success, error)
    }

    /**
     * 任务宝任务宝活动管理页面开启活动
     * @taskId 活动Id
     * @param success
     * @param error
     */
    static getEnterpriseObtainOpenActivity(bodyData, success, error) {
        doPost(URL_GET_ENTERPRISE_OBTAIN_OPEN_ACTIVITY, 'json', bodyData, success, error)
    }

    /**
     * 参与客户列表 的表格数据
     * @param queryParams
     * @param bodyData
     * @param success
     * @param error
     */
    static getActivityCustomerList(queryParams, bodyData, success, error) {
        let query = '?taskId=' + queryParams.taskId +
            '&pageNum=' + queryParams.pageNum +
            '&pageSize=' + queryParams.pageSize +
            '&channelId=' + queryParams.channelId
        doPost(URl_GET_ACTIVITY_CUSTOMER_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 获取 参与用户的 统计数据
     * @param taskId
     * @param success
     * @param error
     */
    static getActivityCustomerStats(taskId, channelId, success, error) {
        let query = `?taskId=${taskId}&channelId=${channelId}`
        doGet(URL_GET_ACTIVITY_CUSTOMER_STATS + query, success, error)
    }

    /**
     * 群发页面 统计客户数据
     * @param followUserIds
     * @param success
     * @param error
     */
    static getActivityMassCountPeopleNumber(bodyData, success, error) {
        doPost(URL_GET_ENTERPRISE_OBTAIN_MASS_COUNT_PEOPLENUMBER, 'json', bodyData, success, error)
    }

    /**
     * 参与用户 --> 获取邀请详情
     * @param cfId
     * @param success
     * @param error
     */
    static getActivityInvitedDetail(cfId, success, error) {
        doGet(URL_GET_ACTIVITY_INVITED_DETAIL + '?cfId=' + cfId, success, error)
    }

    /**
     * 邀请客户列表
     * @param queryParams
     * @param success
     * @param error
     */
    static geyActivityInviteList(queryParams, success, error) {
        let query =
            '?taskId=' + queryParams.taskId +
            '&cfId=' + queryParams.cfId +
            '&pageNum=' + queryParams.pageNum +
            '&pageSize=' + queryParams.pageSize
        doGet(URL_GET_ACTIVITY_INVITE_CUSTOMER_LIST + query, success, error)
    }


    /**
     * 获取微信支付配置
     * @param success
     * @param error
     */
    static getWxPayDetail(success, error) {
        doGet(URL_GET_WXPAY_DETAIL, success, error);
    }

    /**
     * 添加微信支付配置
     * @param data
     * @param success
     * @param error
     */
    static addWxPay(data, success, error) {
        doPost(URL_ADD_WXPAY, 'file', data, success, error)
    }

    /**
     * 获取微信支付目录
     * @param success
     * @param error
     */
    static getWxPayDomain(success, error) {
        doGet(URL_GET_WXPAY_DOMAIN, success, error);
    }

    /**
     * 编辑微信支付配置
     * @param data
     * @param success
     * @param error
     */
    static editWxPay(data, success, error) {
        doPost(URL_EDIT_WXPAY_CONFIG, 'file', data, success, error);
    }

    /**
     * 获取兑换码列表
     * @param success
     * @param error
     */
    static getMarketRedeemCodeList(pageNum, pageSize, success, error) {
        doGet(URL_GET_MARKET_REDEEMCODE_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, success, error);
    }

    /**
     * 新建群发消息
     * @param postData
     * @param success
     * @param error
     */
    static getNewMassInformation(postData, success, error) {
        doPost(URL_GET_NEW_MASS_INFORMATION, 'json', postData, success, error)
    }

    /**
     * 获取群发消息详情
     * @param taskId
     * @param success
     * @param error
     */
    static getMassDetailData(taskId, success, error) {
        doGet(URL_GET_MASS_DETAIL_DATA + '?taskId=' + taskId, success, error)
    }

    /**
     * 导出兑换码
     * @param redeemId
     */
    static exportRedeemCodeData(redeemId) {
        Util.downLoadFile(URL_EXPORT_REDEEMCODE_DATA + '?redeemcodeId=' + redeemId)
    }

    /**
     * 获取批量发货记录
     */
    static getOrderBulkDeliverRecordList(pageNum,pageSize,success,error){
        doGet(URL_GET_ORDER_BULKDELIVER_RECORDLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize,success,error)
    }
    /**
     * 上传批量发货数据
     */
    static getOrderBulkDeliverUploadData(bodyData,success,error){
        doPost(URL_GET_ORDER_BULKDELIVER_UPLOAD_DATA,'file',bodyData,success,error)
    }
    /**
     * 删除批量发货记录
     */
    static getOrderDeliverDelete(bodyData,success,error){
        doPost(URL_GET_ORDER_BULKDELIVER_DELETE,'json',bodyData,success,error)
    }

    /**
     * 企业微信授权状态
     */
    static getEnterpriseWechatAuthoriztionStuatus(success, error) {
        doGet(URL_GET_ENTERPRISE_WECHAT_AUTHORIZTION_STUATUS, success, error)
    }

    /**
     * 获取待开发的二维码
     */
    static getCorpAuthTempkateAuthCode(success, error) {
        doGet(URL_GET_CORP_AUTH_TEMPLATE_AUTH_CODE, success, error)
    }

    // /**
    //  * 获取自建应用功能接口回调信息
    //  */
    // static getApplicationFunctionMessage(success,error){
    //     doGet(URL_GET_APPLICATION_FUNCTION_MESSAGE,success,error)
    // }

    /**
     * 去企业微信授权按钮
     */
    static getGoEnterpriseWeixinAuthoriztion(success, error) {
        doGet(URL_GET_GO_ENTERPRISE_WEIXIN_AUTHORIZTION, success, error)
    }

    /**
     * 获取自建应用功能接口回调信息
     */
    static getCallbackUseMessage(success, error) {
        doGet(URL_GET_CALLBACK_USE_MESSAGE, success, error)
    }

    /**
     * 提交自建应用信息
     * bodyData
     * agentId
     * secret
     */
    static getSubmitSeltBulidUseMessage(bodyData, success, error) {
        doPost(URL_SUBMIT_SELT_BULID_USE_MESSAGE, 'json', bodyData, success, error)
    }

    static getGainSubmitSeltBulidUseMessage(success, error) {
        doGet(URL_SUBMIT_SELT_BULID_USE_MESSAGE, success, error)
    }

    /**
     * 提交客户联系功能密码
     * bodyData
     * secret
     */
    static getSubmitClientRelationPassword(bodyData, success, error) {
        doPost(URL_SUBMIT_CLIENT_RELATION_PASSWORD, 'json', bodyData, success, error)
    }

    static getGainSubmitClientRelationPassword(success, error) {
        doGet(URL_SUBMIT_CLIENT_RELATION_PASSWORD, success, error)
    }

    /**
     *  修改企微授权状态（点下一步时调用）
     * bodyData
     * status
     */
    static getModificationAuthorizationState(bodyData, success, error) {
        doPost(URL_MODIFICATION_AUTHORIZATION_STATE, 'json', bodyData, success, error)
    }

    /**
     *  获取客户授权参数
     */
    static getGainClientAuthorizationParameter(success, error) {
        doGet(URL_GAIN_CLIENT_AUTHORIZATION_PARAMETER, success, error)
    }

    /**
     *  修改客户授权参数
     */
    static getModificationClientAuthorization(bodyData, success, error) {
        doPost(URL_MODIFICATION_CLIENT_AUTHORIZATION, 'json', bodyData, success, error)
    }

    /**
     * 获取微信支付
     * @param success
     * @param error
     */
    static getWxPaySubsInfo(mchType, success, error) {
        doGet(URL_GET_WXPAY_SUBSINFO + '?paytype=' + mchType, success, error)
    }

    /**
     * 同步客户
     * @param success
     * @param error
     */
    static syncCustomer(success, error) {
        doGet(URL_SYNC_CUSTOMER, success, error)
    }

    /**
     * 获取可用表单列表
     * @param success
     * @param error
     */
    static getFormUnvound(bodyData, success, error) {
        doPost(URL_FORM_UNBOUND, 'json', bodyData, success, error)
    }

    /**
     * 获取可用兑换码列表
     * @param success
     * @param error
     */
    static getRedeemcodeUnbindlist(bodyData, success, error) {
        doPost(URL_GET_REDEEMCODE_UNBINDLIST, 'json', bodyData, success, error)
    }

    /**
     * 群裂变活动绑定的兑换码礼品
     * @param success
     * @param error
     * @params fissionId 活动ID
     */
    static getGroupFissionRedeemocodeBinding(fissionId, success, error) {
        doGet(URL_GET_GROUPFISSION_REDEEMCODE_BINDING + '?fissionId=' + fissionId, success, error)
    }

    /**
     * 获取可提现金额
     */
    static getAssetsCashable(success, error) {
        doGet(URL_GET_ASSETS_CASHABLE, success, error)
    }

    /**
     * 申请提现
     * @param params
     * @param success
     * @param error
     */
    static applyWithdraw(params, success, error) {
        doPost(URL_APPLY_WITHDRAW, 'json', params, success, error)
    }

    /**
     * 获取对账单明细
     * @param pageNum
     * @param pageSize
     * @param params
     * @param success
     * @param error
     */
    static getAssetsStatementList(pageNum, pageSize, params, success, error) {
        doPost(URL_GET_ASSETS_STATEMENT_LIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', params, success, error);
    }

    /**
     * 判断群聊是否同步完成
     * @param success
     * @param error
     */
    static getGroupFissionSyncGroupStatus(success,error){
        doGet(URL_GET_GROUPFISSION_SYNCGROUPCHATSTATUS,success,error)
    }
    /**
     * 同步群聊
     * @param success
     * @param error
     */
    static getGroupFissionSyncGroupChatList(success,error){
        doPost(URL_GET_GROUPFISSION_SYNCGROUPCHATLIST,'json',{},success,error)
    }

    /**
     * 获取全部外部群聊列表
     * @param pageNum
     * @param pageSize
     * @param success
     * @param name 模糊搜索
     * @param error
     */
    static getGroupFissionGroupList(pageNum, pageSize, name, fissionId, success, error) {
        doGet(URL_GET_GROUPFISSION_GROUPLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&name=' + name + '&fissionId=' + fissionId, success, error)
    }

    /**
     * 群裂变新建活动
     * @param postData 数据
     * @param success
     * @param error
     */
    static getCorpGroupFissionCreate(postData, success, error) {
        doPost(URL_CORP_GROUPFISSION_CREATE, 'json', postData, success, error)
    }

    /**
     * 群裂变 活动列表
     * @param queryParam
     * @param bodyParam
     * @param success
     * @param error
     */
    static getGroupActivityList(queryParam, bodyData, success, error) {
        let query = `?pageNum=${queryParam.pageNum}&pageSize=${queryParam.pageSize}`
        doPost(URL_GET_GROUP_ACTIVITY_LIST + query, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 编辑活动
     * @param postData 数据
     * @param success
     * @param error
     */
    static getCorpGroupFissionEdit(bodyData, success, error) {
        doPost(URL_CORP_GROUPFISSION_EDIT, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 获取活动信息
     * @param fissionId 活动ID
     * @param success
     * @param error
     */
    static getCorpGroupFissionDetail(fissionId, success, error) {
        doGet(URL_CORP_GROUPFISSION_DETAIL + '?fissionId=' + fissionId, success, error)
    }

    /**
     * 群裂变 删除活动
     * @param fissionId 活动ID
     * @param success
     * @param error
     */
    static getCorpGroupFissionDel(postData, success, error) {
        doPost(URL_CORP_GROUPFISSION_DEL, 'json', postData, success, error)
    }

    /**
     * 群裂变 活动推广
     * @param fissionId
     * @param success
     * @param error
     */
    static getGroupPromoinfo(fissionId, success, error) {
        doGet(URL_GET_GROUP_PROMOINFO + `?fissionId=${fissionId}`, success, error)
    }

    /**
     * 群裂变 关闭活动
     * @param bodyData{fissionId}
     * @param success
     * @param error
     */
    static offGroupActivity(bodyData, success, error) {
        doPost(URL_OFF_GROUP_ACTIVITY, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 开启活动
     * @param bodyData{fissionId,expireAt}活动截止时间
     * @param success
     * @param error
     */
    static openGroupActivity(bodyData, success, error) {
        doPost(URL_OPEN_GROUP_ACTIVITY, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 活动名称下拉列表
     * @param success
     * @param error
     */
    static getGroupActivityNameList(success, error) {
        doGet(URL_GET_GROUP_ACTIVITY_NAME_LIST, success, error)
    }

    /**
     * 群裂变 渠道列表
     * @param params
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupChannelList(params, bodyData, success, error) {
        let query = `?pageSize=${params.pageSize}&pageNum=${params.pageNum}`
        let bodyParams = {fissionId: bodyData.fissionId, channelName: bodyData.channelName}
        doPost(URL_GET_GROUP_CHANNEL_LIST + query, 'json', bodyParams, success, error)
    }

    /**
     * 群裂变 渠道推广
     * @param channelId
     * @param success
     * @param error
     */
    static getGroupChannelPromoinfo(channelId, success, error) {
        doGet(URL_GET_GROUP_CHANNEL_PROMOINFO + '?channelId=' + channelId, success, error)
    }

    /**
     * 群裂变 删除渠道
     * @param channelId
     * @param success
     * @param error
     */
    static deleteGroupChannelById(channelId, success, error) {
        doGet(URL_DELETE_GROUP_CHANNEL + '?channelId=' + channelId, success, error)
    }

    /**
     * 获取渠道下拉列表
     * @param fissionId
     */
    static getGroupChannelMenuList(fissionId, success, error) {
        doGet(URL_GET_GROUP_CHANNEL_MENU_LIST + '?fissionId=' + fissionId, success, error)
    }

    /**
     * 群裂变 活动数据
     * @param params
     * @param success
     * @param error
     */
    static getGroupActivityStats(params, success, error) {
        let query = '?fissionId=' + params.fissionId + '&channelId=' + params.channelId
        doGet(URL_GET_GROUP_ACTIVITY_STATS + query, success, error)
    }

    /**
     * 群裂变 群聊列表
     * @param queryData
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupStats(queryData, bodyData, success, error) {
        let query = `?fissionId=${queryData.fissionId}&channelId=${queryData.channelId}`
        doPost(URL_GET_GROUP_STATS + query, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 客户列表
     * @param queryData
     * @param bodyData
     * @param success
     * @param error
     */
    static getGroupCustomerStats(queryData, bodyData, success, error) {
        let query = `?pageNum=${queryData.pageNum}&pageSize=${queryData.pageSize}&fissionId=${queryData.fissionId}&channelId=${queryData.channelId}`
        doPost(URL_GET_GROUP_CUSTOMER_STATS + query, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 群聊数据导出
     * @param queryData
     * @param success
     * @param error
     */
    static getGroupStatsExport(queryData, success, error) {
        let query = `?fissionId=${queryData.fissionId}&channelId=${queryData.channelId}&groupName=${queryData.groupName}&groupMasterId=${queryData.groupMasterId}&groupStatus=${queryData.groupStatus}`
        doGet(URL_GET_GROUP_STATS_EXPORT + query, success, error)
    }

    /**
     * 群裂变 编辑渠道
     * @param bodyData
     * @param success
     * @param error
     */
    static editGroupChannelInfo(bodyData, success, error) {
        doPost(URL_EDIT__GROUP_CHANNEL_INFO, 'json', bodyData, success, error)
    }

    /**
     *  群裂变 获取渠道详情
     * @param channelId
     * @param success
     * @param error
     */
    static getGroupChannelInfo(channelId, success, error) {
        doGet(URL_GET_GROUP_CHANNEL_INFO + '?channelId=' + channelId, success, error)
    }

    /**
     * 群裂变 新建渠道
     * @param bodyData {fissionId，channelName}
     * @param success
     * @param error
     */
    static createGroupChannel(bodyData, success, error) {
        //let bodyParams = {fissionId: bodyData.fissionId, channelName: bodyData.channelName}
        doPost(URL_CREATE_GROUP_CHANNEL, 'json', bodyData, success, error)
    }

    /**
     * 群裂变 群主下拉列表
     * @param fissionId
     * @param success
     * @param error
     */
    static getGroupMasterList(fissionId, success, error) {
        doGet(URL_GET_GROUP_MASTER_LIST + '?fissionId=' + fissionId, success, error)
    }

    /**
     * 群裂变  邀请详情
     * @param gfId
     * @param success
     * @param error
     */
    static getGroupInvitedDetail(gfId, success, error) {
        doGet(URL_GET_GROUP_INVITED_DETAIL + '?gfId=' + gfId, success, error)
    }

    /**
     * 邀请列表
     * @param queryParams
     * @param success
     * @param error
     */
    static geyGroupInviteList(queryParams, success, error) {
        let query =
            '?gfId=' + queryParams.gfId +
            '&pageNum=' + queryParams.pageNum +
            '&pageSize=' + queryParams.pageSize
        doGet(URL_GET_GROUP_INVITE_CUSTOMER_LIST + query, success, error)
    }

    /**
     * 成员管理 部门树
     * @param success
     * @param error
     */
    static getMemberTree(success, error) {
        doGet(URL_GET_MEMBER_TREE, success, error)
    }

    /**
     * 成员管理 成员列表
     * @param queryData
     * @param success
     * @param error
     */
    static getMemberList(queryData, success, error) {
        let query = `?pageNum=${queryData.pageNum}&pageSize=${queryData.pageSize}&deptId=${queryData.deptId}&name=${queryData.name}`
        doGet(URL_GET_MEMBER_LIST + query, success, error)
    }

    /**
     * 成员管理 同步成员
     * @param success
     * @param error
     */
    static syncMember(success, error) {
        doGet(URL_SYNC_MEMBER, success, error)
    }


    /*
     * 获取需要续费的产品
     * */
    static getProductRenewlis(success, error) {
        doGet(URL_PRODUCT_RENEWLIS, success, error)
    }

    /*
     * 获取订单列表
     * */
    static getProductOrderList(pageSize, pageNum, success, error) {
        doGet(URL_PRODUCT_ORDER_LIST + '?pageSize=' + pageSize + '&pageNum=' + pageNum, success, error)
    }


    /*
     * 01 获取是否到期
     * */
    static getPProductStstus(pType, success, error) {
        doGet(URL_GET_PRODUCT_STATUS + '?pType=' + pType, success, error)
    }

    /*
     * 01 获取组合产品列表
     * */
    static getProductGroupList(success, error) {
        doGet(URL_PRODUCT_GROUP_LIST, success, error)
    }

    /*
     * 01 获取单独产品列表
     * */
    static getProductList(success, error) {
        doGet(URL_GET_PRODUCT_LIST, success, error)
    }

    /**
     * 获取微信支付二维码
     * @param success
     * @param error
     */
    static getProductOrderWxpayQrcode(orderId, success, error) {
        doGet(URL_PRODUCT_ORDER_WXPAY_QRCODE + '?orderId=' + orderId, success, error)
    }

    /**
     * 产品购买下单接口
     * bodyData：{
     *    itemsList:[{
     *     pType://是	1 一元解锁 2 分销 3 拼图 4 企微任务宝 5 企微群裂
     *     duration://期限
     *     timeunit:	0 天 1月 2年
     * }]
     * }
     * @param success
     * @param error
     */
    static getProductOrderUnified(bodyData, success, error) {
        doPost(URL_PRODUCT_ORDER_UNIFIED, 'json', bodyData, success, error)
    }

    /**
     * 计算价格
     * bodyData：{
     *    itemsList:[{
     *     pType://是	1 一元解锁 2 分销 3 拼图 4 企微任务宝 5 企微群裂
     *     duration://期限
     *     timeunit:	0 天 1月 2年
     * }]
     * }
     * @param success
     * @param error
     */
    static getProductOrderCalcprice(bodyData, success, error) {
        doPost(URL_PRODUCT_ORDER_CALCPRICE, 'json', bodyData, success, error)
    }

    /**
     * 提交凭证
     *  nickname  联系人
     *  phoneNo   手机号
     *  voucher   凭证
     *  orderId   订单ID
     * @param success
     * @param error
     */
    static getProductOrderManualReview(bodyData, success, error) {
        doPost(URL_PRODUCT_ORDER_MANUAL_REVIEW, 'json', bodyData, success, error)
    }

    /**
     * 获取支付结果
     * orderID 订单ID
     * @param success
     * @param error
     */
    static getProductOrderWxpayResult(orderId, success, error) {
        doGet(URL_PRODUCT_ORDER_WXPAY_RESULT + '?orderId=' + orderId, success, error)
    }

    /**
     * 取消订单
     * orderID 订单ID
     * @param success
     * @param error
     */
    static getProductOrderClose(orderId, success, error) {
        doGet(URL_PRODUCT_ORDER_CLOSE + '?orderId=' + orderId, success, error)
    }

    /**
     * 席位价格信息
     * @param success
     * @param error
     */
    static getProductProseatPorceinfo(success, error) {
        doGet(URL_PRODUCT_PROSEAT_PIRCEINFO, success, error)
    }


    /**
     * 首页数据
     * @param timesstart
     * @param timesend
     * @param success
     * @param error
     */
    static getHomeData(timesstart, timesend, success, error) {
        let query = `?timesstart=${timesstart}&timesend=${timesend}`;
        doGet(URL_GET_HOME_DATA + query, success, error)
    }

    /**
     * 首页 用户信息
     * @param success
     * @param error
     */
    static getHomeUserInfo(success, error) {
        doGet(URL_GET_HOME_USER_INFO, success, error)
    }

    /**
     * 首页 更新日志
     * @param success
     * @param error
     */
    static getHomeLog(success, error) {
        doGet(URL_GET_HOME_LOG, success, error)
    }

    /**
     * 获取用户openid
     * @param success
     * @param error
     */
    static getUserOpenId(success, error) {
        doGet(URL_GET_USER_OPENID, success, error)
    }

    static getUserLoginStatus(success, error) {
        doGet(URL_USER_LOGIN_STATUS, success, error)
    }

    /**
     * 用户退出登录
     * @param success
     * @param error
     */
    static userExit(success, error) {
        doPost(URL_USER_EXIT, 'json', {}, success, error);
    }


    // 渠道活码
    /**
     * 03 活码分组列表
     * @param success
     * @param error
     */
    static getLiveCodeGroupList(success, error) {
        doGet(URL_LIVECODE_GROUPLIST, success, error)
    }

    /**
     * 03 活码列表
     * @param success
     * @param error
     * @param pageNum
     * @param pageSize
     * bodyData:{
     *     name
     *     groupId
     * }
     */
    static getLiveCodeActivityList(pageNum, pageSize, bodyData, success, error) {
        doPost(URL_LIVECODE_ACTIVITYLIST + '?pageNum=' + pageNum + '&pageSize=' + pageSize, 'json', bodyData, success, error)
    }

    /**
     *06 活码分组新建
     * @param success
     * @param error
     * @param groupName
     */
    static getLiveCodeGroupCreate(bodyData, success, error) {
        doPost(URL_LIVECODE_GROUPCREATE, 'json', bodyData, success, error)
    }

    /**
     *05 活码分组删除
     * @param success
     * @param error
     * @param groupName
     */
    static getLiveCodeGroupDel(bodyData, success, error) {
        doPost(URL_LIVECODE_GROUPDEL, 'json', bodyData, success, onerror)
    }

    /**
     *07 活码分组重命名
     * @param success
     * @param error
     * @param groupName
     * @param groupId
     */
    static getLiveCodeGroupRename(bodyData, success, error) {
        doPost(URL_LIVECODE_GROUPRENAME, 'json', bodyData, success, error)
    }

    /**
     *07 新建渠道码
     * @param success
     * @param error
     * @param postData
     */
    static getLiveCodeCreate(postData, success, error) {
        doPost(URL_LIVECODE_CREATE, 'json', postData, success, error)
    }

    /**
     *07 获取渠道活码单个活码的详情
     * @param success
     * @param error
     * @param bodyData
     */
    static getLiveCodeDetail(id, success, error) {
        doGet(URL_LIVECODE_DETAIL + '?id=' + id, success, error)
    }

    /**
     *07 编辑渠道活码
     * @param success
     * @param error
     * @param bodyData
     */
    static getLiveCodeEdit(bodyData, success, error) {
        doPost(URL_LIVECODE_EDIT, 'json', bodyData, success, error)
    }

    /**
     *09 活码活动删除
     * @param success
     * @param error
     * @param bodyData
     */
    static getLiveCodeeDel(bodyData, success, error) {
        doPost(URL_LIVECODE_DEL, 'json', bodyData, success, error)
    }

    /**
     *12 活码活动批量分组
     * @param success
     * @param error
     * @param bodyData
     */
    static getLiveCodeBatGroup(bodyData, success, error) {
        doPost(URL_LIVE_CODE_BAT_GROUP, 'json', bodyData, success, error)
    }

    /**
     *10 活码活动下载
     * @param success
     * @param error
     * @param activityId
     */
    static getLiveCodeDownLoad(activityId, success, error) {
        doGet(URL_LICE_CODE_DOWN_LOAD + '?activityId=' + activityId, success, error)
    }

    /**
     *04 活码分组列表详情
     * @param success
     * @param error
     */
    static getLiveCodeGroupLiveCode(name, success, error) {
        doGet(URL_LIVE_CODE_GROUP_LIVE_CODE + '?name=' + name, success, error)
    }

    /**
     *13 活码集合数据
     * @param success
     * @param error
     * @param bodyData
     */
    static getLiveCodeStatusSet(bodyData, success, error) {
        doPost(URL_LIVE_CODE_STATS_SET, 'json', bodyData, success, error)
    }

    /**
     *13 活码集合数据列表
     * @param success
     * @param error
     * @param bodyData
     */
    static getLiveCodeStatsSetList(bodyData, success, error) {
        doPost(URL_LIVE_CODE_STATS_SET_LIST, 'json', bodyData, success, error)
    }

    /**
     *21 最新渠道活码
     * @param success
     * @param error
     */
    static getLiveCodeNewActivity(success, error) {
        doGet(URL_LIVE_CODE_NEW_ACTIVITY, success, error)
    }

    /**
     *19 活码对比数据
     * @param success
     * @param error
     */
    static getLiveCodeStatsCompAre(bodyData, success, error) {
        doPost(URL_LIVE_CODE_STATS_COMPARE, 'json', bodyData, success, error)
    }

    /**
     *19 活码对比数据列表
     * @param success
     * @param error
     */
    static getLiveCodeStatsCompareList(bodyData, success, error) {
        doPost(URL_LIVE_CODE_STATS_COMPARE_LIST, 'json', bodyData, success, error)
    }

    /**
     *15 活码集合数据时段详情
     * @param success
     * @param error
     */
    static getLiveCodeStatsSetTimerAnge(bodyData, success, error) {
        doPost(URL_LIVE_CODE_STATS_SET_TIMER_ANGE, 'json', bodyData, success, error)
    }

    /**
     *17 活码集合数据成员客户详情
     * @param success
     * @param error
     */
    static getLiveCodeStatsSetMemberData(bodyData, success, error) {
        doPost(URL_LIVE_CODE_STATS_SET_MEMBER_DATA, 'json', bodyData, success, error)
    }

    /**
     * 计算充值金额
     * @param amount
     */
    static caclRechargeAmount(amount, success, error) {
        doPost(URL_CALC_RECHARGE_AMOUNT, 'json', {amount: amount}, success, error)
    }

    /**
     * 充值下单
     * @param amount
     * @param success
     * @param error
     */
    static unifiedRechargeOrder(amount, success, error) {
        doPost(URL_UNIFIED_RECHARGE_ORDER, 'json', {amount: amount}, success, error)
    }

    /**
     * 获取充值金额
     * @param orderId
     * @param success
     */
    static getAssetsRechargeWxPayQrCode(orderId, success) {
        if (success) {
            success({
                payUrl: URL_GET_ASSETS_RECHARGE_WXPAYQRCODE + '?orderId=' + orderId
            })
        }
    }

    /**
     * 获取充值支付结果
     * @param orderId
     * @param success
     * @param error
     */
    static getAssetsRechargeWxPayResult(orderId, success, error) {
        doGet(URL_GET_ASSETS_RECHARGE_WXPAYRESULT + '?orderId=' + orderId, success, error)
    }
}

export default CorpApi